<template>
  <div v-if="commerce" class="shop-promos-tab no-scrollbar" :key="z" @click="$emit('scrolled')">
    <ShopMenuModal />

    <div v-if="showBasket" class="back-btn-cover" @click="handleBackButton" />

    <ShopMenuMembersOnlyWall ref="wall" v-if="showMembersOnlyWall" :business="business" :w="commerce" @joined="z += 1" />

    <ShopMenuAgentModeWall v-if="showAgentModeWall" :agentModeData="agentModeData" :address="address" :business="business"
      :commerce="commerce" :currency="currency" :deliveryFee="deliveryFee" @close="showAgentModeWall = false"
      @enterAddress="setAgentMode" @placeOrder="tukExpressPlaceOrder" @submit="setAgentMode"
      @reallySubmit="tukExpressPlaceOrder" />

    <ShopItemRemoval v-if="showRemoval" :itemForRemoval="itemForRemoval" :basketItems="basket.items" :lang="lang"
      @close="showRemoval = false" @remove="newRemoveFromBasket" />

    <ShopMenuAgentModeOptions v-if="showAgentModeOptions" :agentModeData="agentModeData" :business="business"
      :w="commerce" :currency="currency" :deliveryFee="deliveryFee" @close="showAgentModeOptions = false"
      @submit="setAgentModeOptions" />

    <!-- <fade-transition class="gpu-accelerated"> -->
    <ShopMenuFulfilmentWall v-if="showBasket && !fulfilmentType" :fulfilmentOptions="fulfilmentOptions"
      :legacyDelivery="commerce.data.express ? true : false" @choose="setFulfilmentType" />
    <!-- </fade-transition> -->

    <fade-transition>
      <ShopMenuOptions v-if="showOptions" :optionsMenus="optionsMenus" :item="selectedItem" :lang="lang"
        :currency="currency" :qty="itemQuantity(selectedItem)" :w="commerce" :isOpen="isOpen" @close="showOptions = false"
        @submit="submitOptions" @remove="advancedRemoval" />
    </fade-transition>

    <ShopMenuFees v-if="showFees" :deliveryFee="deliveryFee" :currency="currency" :surge="surgeFee ? true : false"
      @close="showFees = false" />

    <ShopMenuPreorder v-if="showPreorder" :timeOption="deliveryTimeOption" :dateOption="deliveryDateOption" :lang="lang"
      :currency="currency" :w="commerce" @close="showPreorder = false" @submit="submitOptions" />

    <div v-if="setAddressInitialised">
      <ShopSetDeliveryAddress ref="setDeliveryAddress" v-show="showSetAddress" :key="business.id" :business="business"
        :isAgent="agentModeData" @setLocation="setDeliveryAddress" @editDeliveryNotes="editDeliveryNotes"
        @close="closeSetAddress" />
    </div>

    <!-- v-show="showTimeSelector" -->
    <ShopSetFulfilmentTime v-if="false" @submit="showTimeSelector = false" />

    <div v-show="showBasketCard" class="card" style="margin-top: 1px; margin-bottom: 3px">
      <div v-if="!showBasket" class="card-content" style="padding: 7px">
        <span style="padding: 8px 6px">
          <i v-if="basketWarning" class="fa fa-shopping-basket fa-lg" />
          <i v-else class="fa fa-shopping-cart fa-lg" />
        </span>
        <span @click="toggleBasket" class="has-text-weight-medium">
          <span class="tag is-medium is-white">
            {{ basketItemCount }} {{ $t("menu.items") }}
          </span>
          <span v-show="basketItemCount > 0">
            <span class="has-text-grey link" style="margin: 3px">&nbsp;{{ currency }}{{ totalValue }}&nbsp;</span>
          </span>
        </span>
        <div class="is-pulled-right" style="margin-top: -2px">
          <span v-if="showBasket" class="has-text-info link is-pulled-right" style="margin: 6px 2px; font-weight: 500"
            @click="minimise">
            {{ $t("menu.keep-shopping") }}
          </span>
          <span v-else class="button is-pulled-right is-success pulse" @click="checkout">
            {{ $t("menu.checkout") }}
          </span>
        </div>
      </div>
      <!-- <fade-transition class="gpu-accelerated"> -->
      <div v-if="showBasket">
        <div class="card-content" style="padding: 7px">
          <span class="keep-shopping has-text-info" @click="minimise">
            <i class="fa fa-chevron-left" style="margin-right: 8px" />{{
              $t("menu.keep-shopping")
            }}
          </span>
        </div>
        <div style="height: 8px; background-color: whitesmoke" />
        <div class="basket no-scrollbar">
          <div v-if="fulfilmentType !== 'skip'" class="fulfilment-wrapper">
            <div class="notification is-white" style="padding: 6px 10px" @click="clearFulfilmentType">
              <!-- {{ $t("payment.fulfilment") }}:&nbsp; -->
              <span class="has-text-weight-medium">
                <i class="fa" :class="fulfilmentClass" />
                {{ fulfilmentText }}
              </span>
              <span v-if="!isDelivery && hasDelivery" class="has-text-danger not-delivery">
                *{{ $t("commerce.not-a-delivery") }}
              </span>
              <span v-if="isDinein" class="has-text-link not-delivery">Table {{ tableNumber }}</span>
              <span class="change has-text-grey link">
                {{ $t("change") }}
              </span>
            </div>

            <div v-if="isDelivery" style="margin-top: -3px">
              <div class="notification is-white" style="padding: 6px 10px" @click="openSetAddressModal">
                <span class="has-text-weight-medium" style="margin-right: 4px">
                  {{ $t("delivery.delivering-to") }}:
                </span>
                <span class="has-text-link has-text-weight-medium">{{
                  addressName
                }}</span>
                <span class="is-pulled-right">
                  <i class="fa fa-pencil-alt" />
                </span>
              </div>

              <div v-if="address" class="notes" style="margin-top: -10px">
                <!-- style="border-bottom: 1px solid #ddd; padding-bottom: 4px" -->
                <p v-show="address.address" class="clamp has-text-grey" style="font-size: 0.9em"
                  @click="openSetAddressModal">
                  {{ address.address }}
                </p>
                <p class="address-notes" @click="editDeliveryNotes">
                  <span class="has-text-weight-medium" style="margin-right: 4px">{{ $t("menu.address-notes") }}:</span>
                  <span v-if="address.notes" class="has-text-link">{{
                    address.notes
                  }}</span>
                  <span v-else class="hint">
                    {{ $t("menu.unit-or-instructions") }}
                  </span>
                  <span class="is-pulled-right" style="margin-right: 2px">
                    <i class="fa fa-pencil-alt" />
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div v-if="isDelivery && deliveryPromoMsg && deliveryFare" class="delivery-promo-wrapper is-flex"
            @click="showCurrentBasketValue">
            <span style="flex: 1">{{ deliveryPromoMsg }}</span>
            <span class="has-text-info has-text-weight-medium">
              <i v-if="freeDeliveryRemainder > 0">
                Only {{ currency }}{{ freeDeliveryRemainder }} more!
              </i>
              <i v-else>You got it!</i>
            </span>
          </div>

          <div class="table-wrapper">
            <table class="table is-fullwidth">
              <tbody>
                <tr class="no-bottom-border has-text-weight-medium" @click="togglePics">
                  <td colspan="2">
                    <p style="margin: 1px 2px 5px 2px">
                      <i class="fa fa-shopping-cart fa-sm" />&nbsp;{{
                        $t("commerce.order-details")
                      }}
                      <span class="change link is-pulled-right has-text-grey"><i class="fa fa-camera-retro" /></span>
                    </p>
                  </td>
                </tr>
              </tbody>
              <tbody v-for="(o, i) in basketItems" :key="i" class="items" @click="triggerOptions(o.item)">
                <tr :class="{ 'no-bottom-border': o.item.options }">
                  <td class="wide">
                    <span class="qty-left">{{ o.quantity }}</span>
                    <span v-if="o.item.free_gift" class="has-text-danger"
                      style="font-size: 0.8em; font-weight: 500; opacity: 0.8">
                      <i class="fa fa-gift" />&nbsp;Free Gift
                    </span>
                    {{ itemName(o.item) }}
                    <i v-if="longPrepTime(o.item)" class="fa fa-stopwatch fa-sm has-text-grey" />
                    <p v-if="o.item.by_weight" class="options by-weight">
                      <i class="fa fa-weight fa-sm" />&nbsp;~{{
                        o.item.estimated_weight
                      }}
                      grams per piece *to be weighed*
                    </p>
                    <img v-if="showPics" class="item-img" :class="{ 'contain-img': o.item.contain_image }"
                      v-webp="pic(o.item)" />
                  </td>
                  <td style="white-space: nowrap">
                    {{ currency }}{{ discountedTotalPrice(o.item) }}
                    <i v-show="o.item.discount" class="fa fa-tag has-text-danger discount-tag" />
                  </td>
                </tr>
                <tr v-if="hasOptions(o) || o.item.comment">
                  <td colspan="2" class="td-options">
                    <div class="options">
                      <p v-for="o in o.item.options" :key="o.item">
                        <i class="option-menu">
                          •&nbsp;{{ optionMenuName(o) }}
                        </i>
                        <span v-if="o.option.quantity > 1">{{ o.option.quantity }} x</span>
                        {{ optionItemName(o) }}
                      </p>
                      <p v-if="o.item.comment">
                        <i class="far fa-comment option-menu" />
                        <i class="has-text-link" style="margin-left: 0px">
                          {{ o.item.comment }}
                        </i>
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody>
                <!-- <tr v-if="specialDiscount">
                  <td class="wide">
                    {{ $t("Cash Back") }}
                    <i class="fa fa-tag fa-sm has-text-danger discount-tag" />
                  </td>
                  <td
                    colspan="1"
                    style="white-space: nowrap"
                    class="has-text-success has-text-weight-medium"
                  >
                    −{{ currency }}{{ specialDiscount }}
                  </td>
                </tr> -->
                <tr v-if="fulfilmentDiscountPercent">
                  <td class="wide">{{ fulfilmentText }} Discount</td>
                  <td style="white-space: nowrap">
                    −{{ currency }}{{ fulfilmentDiscountAmount }}
                  </td>
                </tr>
                <!-- <tr v-if="true">
                    <td class="wide">Promo: SMASH</td>
                    <td style="white-space: nowrap">
                      −{{ currency }}{{ promoDiscountAmount }}
                    </td>
                  </tr> -->
                <tr v-if="vat">
                  <td class="wide">
                    {{ $t("VAT") }}
                  </td>
                  <td style="white-space: nowrap">{{ currency }}{{ vat }}</td>
                </tr>
                <tr v-if="isDelivery">
                  <td class="wide" @click="showFees = true">
                    <span @click="deliveryBreakdown">
                      {{ $t("menu.fees") }}
                    </span>
                    <span style="padding-right: 50px">
                      <i v-if="surgeFee" class="fa fa-umbrella fa-sm has-text-link" style="margin-right: 6px" />
                      <i class="fa fa-info-circle fa-sm" style="color: #ccc" />
                    </span>
                  </td>
                  <td v-if="isFreeDelivery" style="font-weight: 500; white-space: nowrap">
                    {{ $t("free") }}
                  </td>
                  <td v-else style="white-space: nowrap">
                    <span v-if="actualDeliveryFee">
                      {{ currency }}{{ actualDeliveryFee }}
                      <i class="fa fa-tag has-text-danger discount-tag" />
                    </span>
                    <span v-else>
                      <i class="fa fa-spinner fa-spin has-text-grey" />
                    </span>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th class="wide" style="white-space: nowrap">
                    <span class="qty-total">{{ basketItemCount }}</span>
                    {{ $t("menu.items") }}
                    <span class="is-pulled-right">
                      <span v-if="isSOL" class="total-sol-2">
                        {{ totalValueSOL }} SOL</span>{{ $t("menu.total") }}</span>
                  </th>
                  <th v-if="totalValue" @click="clearBasket">
                    {{ currency }}{{ totalValue }}
                  </th>
                  <th v-else><i class="fa fa-spinner fa-spin" /></th>
                </tr>
              </tfoot>
            </table>
          </div>

          <!-- <div
            v-if="cashback"
            class="notes"
            style="background-color: lightyellow"
            @click="showCNXPromoInfo"
          >
            <i class="has-text-link">{{ $t("promos.cashback-promo") }}</i>
            <span class="is-pulled-right label">
              {{ youGetXCashback }}
            </span>
          </div> -->

          <div v-if="!showOrderOptions" class="delivery-promo-wrapper is-flex" @click="showOrderOptions = true">
            <span style="flex: 1"><i class="has-text-grey">
                <i class="far fa-edit icon" style="display: inline-block; height: 0" />{{
                  $t("menu.additional-order-notes") }}
              </i></span>
            <span class="has-text-info has-text-weight-medium">
              More Options
            </span>
          </div>

          <div v-if="showOrderOptions" class="delivery-promo-wrapper">
            <div class="order-option-row" @click="editOrderNotes">
              <span v-if="orderNotes" class="has-text-link">
                <i class="far fa-comment-alt has-text-grey icon" />
                {{ orderNotes }}
                <span class="change has-text-grey link">
                  {{ $t("edit") }}
                </span>
              </span>
              <span v-else>
                <i class="has-text-grey">
                  <i class="far fa-edit icon" />{{
                    $t("menu.additional-order-notes")
                  }}
                </i>
              </span>
            </div>

            <div v-if="!isLessPlastic && !isDineInOnly" class="order-option-row" @click="setLessPlastic">
              <i class="far fa-square has-text-success icon" />
              <i class="has-text-grey">Go Green? No cutlery, less plastic</i>
            </div>

            <div v-if="isDelivery && !isLalamove" class="order-option-row" @click="contactlessDelivery">
              <p v-if="isContactlessDelivery" class="isContactlessDelivery">
                <i class="far fa-check-circle has-text-info icon" />
                <span class="has-text-info">Contactless delivery</span>
                {{ contactlessNote }}
                <span class="change has-text-grey link">
                  {{ $t("edit") }}
                </span>
              </p>
              <p v-else>
                <i class="far fa-square has-text-grey icon" />
                <i class="has-text-grey">Contactless Delivery? Leave it at ...</i>
              </p>
            </div>

            <div v-if="isDelivery" class="order-option-row" @click="editGiftDetails">
              <span v-if="giftDetails" class="has-text-link">
                <i class="fa fa-gift has-text-grey icon" />
                Gift recipient: {{ giftDetails.recipient_phone }}
                <span class="change has-text-grey link">
                  {{ $t("edit") }}
                </span>
              </span>
              <span v-else>
                <i class="has-text-grey">
                  <i class="fa fa-gift icon" />{{ "Is this order a gift?" }}
                </i>
              </span>
            </div>

            <div v-if="isDelivery" class="order-option-row" @click="enterPromoCode">
              <i class="fa fa-percentage icon has-text-grey" />
              <i class="has-text-grey">{{ $t("promo-code") }}</i>
              <span class="link is-pulled-right has-text-primary hint is-uppercase">{{ deliveryPromoCode }}</span>
            </div>
          </div>

          <div v-if="showDiscountApplied" style="font-size: 0.85em">
            <i class="fa fa-tag has-text-danger" style="opacity: 0.7; font-size: 0.7em; margin: 0 4px" />
            <i>{{ $t("menu.discount-applied") }}</i>
            <p v-if="minOrder && basketValue < minOrder" class="has-text-black is-pulled-right">
              <i>{{ minOrderText }}</i>
            </p>
          </div>

          <div v-if="deliveryTimeOption" class="notification is-white pulse" style="padding: 6px 10px; margin-top: 10px"
            @click="openPreorder">
            Select Delivery Time
          </div>
          <div style="height: 100px" />

          <!-- <div class="bottom-pay-btn">
            <a
              v-if="fulfilmentType === 'skip'"
              class="button is-medium is-info is-fullwidth pulse"
              @click="fulfilmentType = null"
            >
              {{ $t("commerce.choose-fulfilment-method") }}
            </a>
            <a
              v-else
              class="button is-medium is-success is-fullwidth pulse"
              @click="preSubmit"
            >
              {{ $t("payment.go-to-payment") }}
            </a>
          </div> -->
        </div>
      </div>
      <!-- </fade-transition> -->
    </div>

    <div ref="scrollable" class="scrollable no-scrollbar gpu-accelerated" :class="{ 'scrollable-short': showBasketCard }"
      v-on:scroll.passive="closeBasketAndHowTo">
      <div class="card" style="margin-top: 1px; margin-bottom: 0px">
        <div class="card-content" style="padding: 10px">
          <span class="tag has-text-grey is-rounded" @click="toggleHowTo">
            <i class="fa fa-info" style="padding: 2px" />
            <slide-x-left-transition>
              <button v-if="showHowTo" class="delete is-white" style="box-shadow: 0 0 1px grey" />
            </slide-x-left-transition>
          </span>
          <!-- <fade-transition> -->
          <!-- <span v-if="!isInit" style="margin-left: 2px"> -->
          <span v-if="isDineInOnly">
            Dine-in
            <span class="has-text-link link">Table 14</span>
          </span>
          <span v-else class="has-text-danger" style="font-size: 0.9em; font-weight: 500; margin-left: 4px">
            <span @click="toggleHowTo">{{ deliveryPromoMsg }}</span>
            <span v-if="deliverySubsidyPercent">
              <span v-if="!freeDeliveryOver" class="has-text-link link" style="margin-left: 4px"
                @click="openSetAddressModal">{{ $t("profile.set-address") }}
                <i class="fa fa-map-marker-alt" />
                <!-- <span v-if="variesTimer">{{
                      $t("profile.set-address")
                    }}</span>
                    <span v-else
                      >{{ $t("menu.depends-on") }}
                      <i class="fa fa-map-marker-alt"
                    /></span> -->
              </span>
            </span>
          </span>
          <!-- </span> -->
          <!-- </fade-transition> -->
          <span class="is-pulled-right">
            <span class="buttons">
              <span v-for="(l, i) in languages" :key="i" class="
                                                              button
                                                              is-small
                                                              has-text-weight-medium
                                                              is-uppercase is-rounded
                                                            " :class="{ 'no-border': lang !== l }"
                style="padding: 3px 4.5px; margin: 0; color: grey" @click="setMenuLanguage(l)">
                {{ l }}
              </span>
            </span>
          </span>
        </div>

        <div v-if="isTestFleet" class="card test-only" style="margin-top: 1px; margin-bottom: 0px" @click="testOrderInfo">
          <div class="card-content" style="padding: 10px">
            TEST Order Only
            <i class="fa fa-info-circle fa-lg is-pulled-right" style="padding: 3px 0" />
          </div>
        </div>

        <div v-if="multipleLocations" class="card" style="margin-top: 1px; margin-bottom: 0px" @click="viewLocations">
          <div class="card-content" style="padding: 10px">
            <span class="tag has-text-grey is-rounded" style="padding: 0 7px">
              <i class="fa fa-map-marked-alt fa-sm" style="padding: 0" />
            </span>
            <span style="font-size: 0.85em; font-weight: 500; margin-left: 4px">{{ $t("menu.shop-has-multiple-locations")
            }}</span>
            <span class="tag is-pulled-right has-text-link has-text-weight-semibold">{{ $t("menu.view-locations")
            }}</span>
          </div>
        </div>

        <div v-if="userIsMember" class="card" :class="{ 'member-selected': filterMemberItems }"
          style="margin-top: 1px; margin-bottom: 0px" @click="viewMemberDeals">
          <div class="card-content" style="padding: 10px">
            <span class="tag has-text-primary is-rounded" style="padding: 0 7px">
              <i class="fa fa-check fa-sm" /> </span><span
              style="font-size: 0.85em; font-weight: 500; margin-left: 4px">You're a member</span>
            <span class="tag is-pulled-right has-text-weight-semibold">
              <span v-if="filterMemberItems"><i class="fa fa-chevron-left" />&nbsp;View All Items</span><span v-else
                class="has-text-primary">View Member Deals&nbsp;<i class="fa fa-chevron-right" /></span></span>
          </div>
        </div>

        <!-- <div style="height: 8px; background-color: whitesmoke" /> -->
        <collapse-transition>
          <div v-if="showHowTo" class="has-text-left">
            <div class="notification">
              <p>
                {{ $t("options") }}:
                <span v-if="fulfilmentOptions.length" class="has-text-link">{{
                  fulfilmentOptionsString
                }}</span>
                <span v-else class="has-text-link">
                  {{ $t("commerce.delivery") }}, {{ $t("commerce.take-away") }},
                  {{ $t("commerce.dine-in") }}
                </span>
              </p>
              <p v-if="freeDeliveryTo">
                {{ $t("delivery.free-delivery-to") }}
                <span class="has-text-link" @click="gotoInfo">
                  {{ freeDeliveryTo }}
                  <i class="fa fa-external-link-alt fa-sm" />
                </span>
              </p>
              <p v-if="freeDeliveryOver">
                <span v-if="freeDeliveryOver === -1">
                  {{ $t("delivery.free-delivery") }}
                  <span class="has-text-link">{{ $t("menu.all-orders") }}</span>
                </span>
                <span v-else>
                  {{ $t("delivery.free-delivery-over") }}
                  <span class="has-text-link">
                    {{ currency }}{{ freeDeliveryOver }}
                  </span>
                </span>
              </p>
              <p v-if="deliverySubsidyPercent">
                Order more get
                <span class="has-text-link">cheaper delivery</span>
              </p>
              <p v-if="maxDeliveryDistance" @click="showDeliveryPricingArray">
                {{ $t("menu.max-delivery-distance") }}
                <span class="has-text-link">{{ maxDistKM }} km</span>
                <span v-if="isPeakHour" class="tag is-white is-pulled-right"><i class="far fa-clock" />&nbsp;Peak
                  Hour</span>
              </p>
              <p v-if="minOrder">
                {{ $t("menu.minimum-order") }}
                <span class="has-text-link">{{ currency }}{{ minOrder }}</span>
              </p>
            </div>
          </div>
        </collapse-transition>
      </div>

      <collapse-transition>
        <div v-if="showPreface">
          <!-- <div
            v-if="userIsMember"
            class="preface has-text-primary"
            style="padding-bottom: 0; font-weight: 500"
          >
            <i class="fa fa-check-circle" />&nbsp;You're a member of this shop
          </div> -->

          <div v-if="dineInItems.length" class="dinein-wrapper">
            <p class="has-text-grey" :class="{ 'mb-10': !preface }">
              Eating at the shop?
              <span style="margin-top: -2px" class="is-pulled-right">
                <span class="tag dine-in-hint">Show dine-in items</span>
                <toggle-button :value="showDineInItems" :color="{ checked: '#00D1B2', unchecked: 'grey' }" :sync="true"
                  :height="22" :width="38" @change="setDineIn($event.value)" />
              </span>
            </p>
          </div>

          <div v-if="preface" class="preface" @click="clamped = !clamped">
            <p :class="{ clamp: clamped }">
              <!-- <p style="white-space: pre-wrap"><i> -->
              {{ preface }}
              <!-- </i></p> -->
            </p>
          </div>

          <div v-else style="height: 2px" />
        </div>
      </collapse-transition>

      <ShopMenuSkeleton v-if="!promos" />

      <ShopMenuCategories v-if="categories" ref="categories" :categories="categories" :lang="lang"
        :hasSpecials="specialItems.length > 0" :items="items" :searchParam="search" @setCategory="onSetCategory"
        @searchMenu="onSearchMenu" @enter="onSearchEnter" style="position: sticky; top: 0; z-index: 2" />

      <div v-if="promos && !items.length" class="search-no-result" @click="clearSearch">
        <i class="fa fa-search has-text-grey" style="margin-right: 6px" />
        No items matched your search
        <span class="link has-text-info" style="margin-left: 6px">Try Again</span>
      </div>

      <div v-if="fulfilmentType">
        <div v-if="fulfilmentDiscountPercent" @click="handleFulfilmentDiscountClick">
          <div class="notification is-white has-text-info flash-deals">
            <i class="fa fa-tag fa-sm has-text-danger" />
            {{ fulfilmentDiscountPercent * 100 }}%
            <span v-if="isTakeaway">{{ $t("commerce.self-pickup") }}</span>
            <span v-if="isDinein">{{ $t("commerce.dine-in") }}</span>
            <span style="margin-left: 4px">{{
              $t("menu.discount-applied")
            }}</span>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="takeawayDiscount" @click="setFulfilmentType('take-away')">
          <div class="notification is-white flash-deals">
            <i class="fa fa-walking" style="margin-right: 4px" />
            {{ $t("commerce.self-pickup") }} Discount
            <span class="is-pulled-right">
              <i class="fa fa-tag fa-sm has-text-danger" />
              {{ takeawayDiscount }}% OFF
              <i class="fa fa-chevron-right" style="margin-left: 6px" />
            </span>
          </div>
        </div>

        <div v-if="dineinDiscount" @click="setFulfilmentType('dine-in')">
          <div class="notification is-white flash-deals">
            <i class="fa fa-users" style="margin-right: 4px" />
            {{ $t("commerce.dine-in") }} Discount
            <span class="is-pulled-right">
              <i class="fa fa-tag fa-sm has-text-danger" />
              {{ dineinDiscount }}% OFF
              <i class="fa fa-chevron-right" style="margin-left: 6px" />
            </span>
          </div>
        </div>
      </div>

      <div v-if="freeGift" @click="showFreeGift">
        <div class="notification is-white flash-deals red">
          <span>
            <i class="fa fa-gift" style="margin-right: 4px" />
            Free Gift
            <span class="is-pulled-right">
              Over {{ currency }}{{ freeGift.free_gift }}
              <!-- <span
                v-for="(amount, i) in freeGiftOver"
                :key="i"
                style="margin-right: 6px"
                >{{ currency }}{{ amount }}</span
              > -->
              <i class="fa fa-chevron-right" style="margin-left: 6px" />
            </span>
          </span>
        </div>
      </div>

      <div v-if="promoCodes" @click="enterPromoCode">
        <div class="notification is-white flash-deals red">
          <span>
            <i class="fa fa-percentage" style="margin-right: 4px" />
            Promo Code
            <span class="is-pulled-right">
              <i class="fa fa-chevron-right" style="margin-left: 6px" />
            </span>
          </span>
        </div>
      </div>

      <div v-if="flashDeals.length" @click="toggleFlashDealFilter">
        <div class="notification flash-deals" :class="filterFlashDeals ? 'is-warning' : 'is-white'">
          <span v-if="filterFlashDeals">
            <i class="fa fa-chevron-left" style="margin-right: 6px" />Show All
          </span>
          <span v-else>
            <i class="fa fa-bolt" style="margin-right: 4px" />
            Flash Deals
            <span class="is-pulled-right">
              Show {{ flashDeals.length }}
              <i class="fa fa-chevron-right" style="margin-left: 6px" />
            </span>
          </span>
        </div>
      </div>

      <div v-if="!searchTerm && !filterFlashDeals && !filterMemberItems" :class="{ 'grid-view-wrapper': !listView }">
        <div v-for="(o, i) in specialItems" :key="'s' + i">
          <ShopMenuItem :ref="'special' + o.id" :data-category="'Specials'" class="cat" :o="o" :qty="itemQuantity(o)"
            :lang="lang" :currency="currency" :previousCategory="'Specials'" :isList="listView" :member="userIsMember"
            :instagram="instagram" :country="business.country" @add="addToBasket(o, true)"
            @remove="removeFromBasket(o, true)" />
        </div>
      </div>

      <div :class="{ 'grid-view-wrapper': !listView }">
        <div v-for="(o, i) in items" :key="'n' + i">
          <ShopMenuItem :ref="o.id" :data-category="cleanCat(o.category)" class="cat" :o="o" :qty="itemQuantity(o)"
            :lang="lang" :currency="currency" :previousCategory="previousCategory(items, i)" :isList="listView"
            :member="userIsMember" :instagram="instagram" :country="business.country" @add="addToBasket(o, true)"
            @remove="removeFromBasket(o, true)" />
        </div>
      </div>

      <div v-if="outOfStockCount" class="toggle-out-of-stock" @click="hideOutOfStock = !hideOutOfStock">
        <span class="link">
          <span v-if="hideOutOfStock"><i class="far fa-eye" />&nbsp;Show</span>
          <span v-else><i class="far fa-eye-slash" />&nbsp;Hide</span>
          Out of Stock ({{ outOfStockCount }})
        </span>
      </div>

      <!-- manual menu item entry -->
      <!-- show if agent mode = true in url -->
      <div v-if="showManualItemEntry" class="card" :class="{ 'pulse-background': pulseAgentMode }"
        style="margin-top: 12px">
        <div class="card-content">
          <div class="media" style="margin-bottom: 0">
            <div class="media-left" @click="openMenu">
              <figure class="image" style="opacity: 0.3">
                <img :src="menuImg" v-img-fallback="imgFallback" />
                <i class="fa fa-menu" />
              </figure>
            </div>
            <div class="media-content" style="margin-right: 0px">
              <p class="has-text-weight-medium" style="font-size: 0.8em">
                {{ $t("menu.menu-item") }}
                <i v-if="!commerce.data.menu" class="is-pulled-right has-text-grey">Commerce Agent Only</i>
              </p>
              <div class="field" style="margin-bottom: 5px">
                <input class="input" type="text" v-model="manualItemName" :placeholder="manualItemPlaceholder" />
              </div>
              <span class="is-pulled-right" style="margin: 8px 0; opacity: 0.3" @click="manualItemInfo">
                <i class="fa fa-info-circle fa-lg" />
              </span>
              <div class="field has-addons">
                <div class="control has-icons-left">
                  <input class="input" style="width: 120px" type="number" v-model="manualItemPrice"
                    :placeholder="manualPricePlaceholder" />
                  <span class="icon is-left has-text-weight-bold" style="z-index: 0">
                    {{ currency }}
                  </span>
                </div>
                <div class="control">
                  <a class="button is-info" style="padding: 5px 14px" @click="addManualItem">
                    <i class="fa fa-chevron-right" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <p class="has-text-grey" style="margin-top: -16px" @click="openMenu">
            <span class="link">{{ $t("menu.order-anything") }}</span>
          </p>
        </div>
      </div>

      <div class="notification has-text-grey" style="margin-top: 12px; margin-bottom: 72px">
        <p>
          <i>{{ $t("menu.anything-missing") }}</i>
        </p>
        <p>
          <i>{{ $t("menu.have-a-suggestion") }}</i>
        </p>
        <p class="button is-grey has-text-grey is-fullwidth" style="margin-top: 6px" @click="messageBusiness">
          {{ $t("menu.send-a-suggestion") }}
          <i class="far fa-comment-dots" style="margin-left: 8px" />
        </p>
        <p v-if="superuser && invalidPrices.length" class="button is-light has-text-danger" style="margin-top:6px"
          @click="showInvalidPrices">
          {{ invalidPrices.length }} Invalid Prices</p>
      </div>
    </div>

    <div v-if="basketItemCount > 0" class="bottom-checkout-wrapper">
      <p class="button is-medium is-success checkout pulse" @click="checkout">
        <span class="is-pulled-left">
          {{ $t("menu.checkout") }}
        </span>
        <span class="is-pulled-right items-price">
          {{ basketItemCount }} {{ $t("menu.items") }}
          <span class="vertical-divider">|</span>
          <span style="margin-left: 12px">
            {{ currency }}{{ totalValue }}
          </span>
        </span>
      </p>
    </div>

    <div v-if="showBasket" class="bottom-pay-btn">
      <a v-if="fulfilmentType === 'skip'" class="button is-medium is-info is-fullwidth pulse"
        @click="fulfilmentType = null">
        {{ $t("commerce.choose-fulfilment-method") }}
      </a>
      <a v-else-if="fulfilmentType" class="button is-medium is-success is-fullwidth pulse" @click="preSubmit">
        {{ $t("payment.go-to-payment") }}
      </a>
      <a v-else class="button is-medium is-grey is-fullwidth"
        style="display: block; text-align: left; color: #aaa; padding: 7px 12px" @click="fulfilmentType = 'skip'">
        <i class="fa fa-shopping-basket" />&nbsp;
        {{ $t("menu.view-basket") }}
        <i class="fa fa-chevron-down is-pulled-right" style="margin-top: 4px" />
      </a>
      <!-- style="
          margin: 12px;
          padding: 12px;
          border: 1px solid #ddd;
          background-color: white;
          color: grey;
          font-size: 1.5em;
          font-weight: 500;
        " -->
    </div>

    <div v-if="scrollTopPos > 200 && !showBasket" class="go-up-btn" @click="scrollToTop">
      <i class="fa fa-chevron-up" />
    </div>

    <!-- <slide-y-down-transition> -->
    <ShopSubmitOrder v-if="showSubmit" :business="business" :commerce="commerce.data" :currency="currency"
      :fulfilment="fulfilmentType" :totalItems="basketItemCount" :totalValue="totalValue" :address="address"
      :cashback="cashback" :agentModeData="agentModeData" :deliveryFee="deliveryFee" :shopDeliveryFee="shopDeliveryFee"
      :delayedDelivery="delayedDelivery" :isThirdPartyDelivery="isLalamove" :isContactlessDelivery="isContactlessDelivery"
      :isTestFleet="isTestFleet" :workflowID="commerce.id" @close="showSubmit = false" @cashback="enterPromoCode"
      @submit="submit" @clearFulfilment="fulfilmentType = null" @editAgentOrder="showAgentModeWall = true" />
    <!-- </slide-y-down-transition> -->
  </div>
  <div v-else class="notification is-warning" style="margin-top: 10px">
    <p>This shop doesn't have any promos at the moment.</p>
    <p style="margin-top: 12px">That we know about...</p>
  </div>
</template>

<script>
import EventBus from "../eventBus";
import ShopMenuModal from "@/components/ShopMenuModal";
import ShopMenuItem from "@/components/ShopMenuItem";
import ShopMenuCategories from "@/components/ShopMenuCategories";
import ShopMenuOptions from "@/components/ShopMenuOptions";
import ShopSubmitOrder from "@/components/ShopSubmitOrder";
import ShopSetDeliveryAddress from "@/components/ShopSetDeliveryAddress";
import ShopSetFulfilmentTime from "@/components/ShopSetFulfilmentTime";
import ShopMenuMembersOnlyWall from "@/components/ShopMenuMembersOnlyWall";
import ShopMenuFulfilmentWall from "@/components/ShopMenuFulfilmentWall";
import ShopMenuAgentModeWall from "@/components/ShopMenuAgentModeWall";
import ShopMenuAgentModeOptions from "@/components/ShopMenuAgentModeOptions";
import ShopItemRemoval from "@/components/ShopItemRemoval";
import ShopMenuSkeleton from "@/components/ShopMenuSkeleton";
import ShopMenuFees from "@/components/ShopMenuFees";

import geo from "@/geo";
import codes from "@/codes";
import pricing from "@/pricing";

const shortid = require("shortid");

export default {
  name: "ShopPromosTab",
  components: {
    ShopMenuModal,
    ShopMenuItem,
    ShopMenuCategories,
    ShopMenuOptions,
    ShopSubmitOrder,
    ShopSetDeliveryAddress,
    ShopSetFulfilmentTime,
    ShopMenuMembersOnlyWall,
    ShopMenuFulfilmentWall,
    ShopMenuAgentModeWall,
    ShopMenuAgentModeOptions,
    ShopItemRemoval,
    ShopMenuSkeleton,
    ShopMenuFees,
  },
  props: {
    tableNumber: String,
    deliveryWorkflows: Object,
    view: String, // "list" or "grid"
    instagram: Boolean,
    search: String, // from url param
  },
  data() {
    return {
      songkranMinOrder: 0,
      hideOutOfStock: true,
      showOrderOptions: false, // orders notes, go green, gift order, promo code etc
      giftDetails: null, // fields: recipient_phone, recipient_note
      paymentMethod: null,
      showFees: false,
      showPreface: true,
      filterMemberItems: false,
      filterFlashDeals: false,
      lalamoveQuote: null, // set after we get a successful quote from lalamove
      setAddressInitialised: false, // set to true after first time opening
      itemForRemoval: null,
      showRemoval: false,
      whoPaysDelivery: null,
      agentModeData: null,
      showAgentModeWall: false,
      showAgentModeOptions: false,
      showPics: false,
      showTimeSelector: false,
      showSetAddress: false,
      variesTime: 0,
      deliveryPromoCode: null,
      width: 1000,
      showHowTo: false,
      showDineInItems: false,
      lang: this.$store.state.language, // default content lang initially (user can change it)
      basket: null, // shopping basket -- should come from $store
      showBasket: false,
      fulfilmentType: null, //-- delivery by default
      manualItems: [],
      manualItemName: null,
      manualItemPrice: null,
      menuImg: `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAflBMVEX///8CAgIAAADk5ORQUFDV1dVcXFxYWFiSkpIrKyvp6elGRkbz8/O9vb3v7+9+fn7b29swMDB4eHj5+fnNzc3GxsZsbGy2trY3NzdycnJmZmampqacnJytra2zs7OkpKSXl5dJSUmLi4s1NTUiIiI/Pz8SEhIZGRklJSWEhIR+9H6tAAAKpUlEQVR4nO2d2ZajIBCG28raSUyMS8y+dZbJ+7/gCIjRNIIgKn0O/8XMxHHhE6SKosSvLysrKysrKysrKysrKysrKysrKysrKyt96oXucX/1V9tEq81ivIvdwazrQunRPDz5owew9bN9xYOuS1hDwWC/pSwOS+n/fS/iXtdlVZB36pej/eZ8+u686yLLKHx9V8TLU/Z3k64LXk3e6ylFl6fsH4Kuiy/S7LRUoctBbsOuGXjyNjXwMsjbztSKDPu1+WhFXk3sdqK7Fj4KuTCNMdTIlzK+TGqr3kUrHmU8d81FNfP18xHGh9s1G9ZBb/ssMva79+cm08b4COO5Y8BTo3wYcel1yNdwBVLGfWeAbgt8GLHfkXF8tQOIGJ0unNXZvTXAblrqoEU+jLhtGTBuFxAx3lt9GM+tAyaIjxat/6IpQO5pAVqLy2318xWCjOU7Re0AjrQC0pDi8BUPgq95dOb00QCtuOJDTYC0xtbDcezlx4LhjYMYNw+oo4nSetue4x4jth+WX6KFhrqqB0jZ/HPklY7hJ5xrADTs3viqgLRNXvx9JOr1eYTJiRoda4wVAFO0W98/RNWMNpcwOV+DoXE5T4ZW2+3yOoRzibgSn9CBf43FqKr7ohRudD148ndcQOjApQE4pHnlmSSA5/YaK0+BiggdWGgFy7QWPB5E9+3YrdkXCAkdOOpBKmrBscNIj/tq7/Z0PCIVCJvoUMtDFvBY+6doou/xFxM68K3talTlDyE4P9P7fb1cfmtTled9o5vwwrwqI/ugAbGvrNkJ37Muk1z80m9cyzJErdkqPdZVANqZk/ambEStkZs7E7C1IXefjaixnR6YbfSl7wICTZgNFRxtTWjGvkCL8wkl/Zw214Y5ZAJoMfTFjitos/seuwq7J9TmgrMjTyYQOnpiGlGZPTKBcKnj7CVDCiMIHR2xt5IqNIVQQyWWjQrNINRQiaWxS1MIa1ci22Eyh7B2d8q2hUYR1rSJG07oQolQLWLNI6zn2LA90hqEA1DylnmzQfW80xPv3qkQrtSiD1xCtZuWihMxUSKcg9qokjujBweFM6biBbmVCM/gwFqhIHzCGn3Ni9s4KhEW+nIcsIPVPnZDj0RZKj5DfMIaUzW8MH5Fwn9n8ncvGg/TsBkJoOFSzSpmAvHnndXTiThzsdUI59EVYLVAMONCWBAcNM/m+v+SjT8VOgoB4V2VkNdIKxFOlpAlbOVj5rQGk4LDrUoTExAqOx/lGQOVT3tP6ij9p/eE7NDUSAcPgGGVkgiyI+CkBuhpuHHLxyjrBwLq42bPzRyu40qBXRGhYm/KMfdVCYNz0sdk+9GgJIzSDTNUl1XstYhQMf7NzwxSaPxofg71NwCyR4pyeNQGGAF/yleBEJuLCyj4NULCq2xZkAailiFNmMCt5l+eL58PKyRUGgfzH0MFwsBZkroL9rKTKsJMM+l2X+Gs8oQzdQ9ZTKgy7uRaQ3PG+GlpFBw39nyPsYQKw06uU2oe4Y/4JJ9izmubS6jQ1ZSnz7AJJ4kKnkWAtiR/zyYFBV/p9txx83SvoLA1t5M4a1chHsWa2OYQesiQ9/NbtqlpvxYTK454zxXdC8U10LDfR39nHeIM/bpJEcpPeYuS2D4IQ1z83KYJ3hClI8O34h4BzRNOcfr/J2HOilcglB5eCHy2X4Qu2h389wY8uERBIpyTWiTMHY0CG4Qwb9RQFFOSMHfpaioPdrMJj4QjexLJHUJmagyFzCJCmAWktBFWGmfmJfBKfxGSrvf9xueO/B6nhPFXkIreuzSVQxvhVJYwkiQkEQ940N9kQI/aDibM9QOUkIx4tBFKp/LtJAnTHH7ag7jpz1EJIR4lBjoJpQfBwpz1D8J0uEx9i+n7J4sQHuiPvlZC2VfbuHE2BuGFVkxIKPAvB5yUMDsqJIQ+ytFB/VB3hCKX5pMQxQ1vP5DGYDaomu4kXlG0FinhBg1dkEOgi9CRDnwLXx0pEgaPpEiXHZDNuNjjDXnWCu2dEq7wnEjitsy0Ecq6bZKEuEijL9wAkaOGnnyf8BbrMKKEpPWuvrQRysZ+yid/mYRz0vReuNoCBzPgHx4h2fVSBRkh9nxh//gjhLhrGeNMWzgdCdqZFJrZlyLCCe6ZHEJ4BSf3jgE+Ty7M2wShZCtFDgJyftFMxPKbWIIjQSslTHYA0uNO051fhdOt3scYQBgDcbMHtNBRWswdhzBzE6bUvtB9RlAcLRjQ0+woBjH12IcKScsdQzEmnSNMo13Yp0Q2k6ZuYycXpEbAjnTIQdLiozLhdkLcNfxE4WpZEMI7zbyfRr0cIZlGx4R4UgNu4+Nxj9cTKQwWqhDKWvyrHCHuCvFNX2bNbQ44BsYaH2bP2DkjxF4R3e/TR2nCpxEFoj4It0CvgdvrGW8E7HoXPdwPQmIyMGF+oY3PqY0mPO+jHOEa3XlyjeK/nuw4TRbWp3EaclczbYrlrUD4kM2qEYVLP62Fm4j8c+C6qeV28UbPzSvuzWI32yMR+u+sH4qu2+Fwu4g/66MCoXQSi/B9UbPipU4xzldFoqC+cYTy7wj9NUL5OdLnHyOUf29WOO1qGKH8TL4oUGMaofwKRCKDaBahytyTKOhtGKG0seAmQDMI3ZF29XMjLjGhSio0f4GBD8Jv0K9cFFtMqPJiiSCeWCQcjPUr53uLCVUeGUFXY9RzqNLRCP02swjV3ute/iFCtQRTfqjGJELV92bcv0P4EJ+CJf5UvlGE0pP4qbgptEYRqr6hx50HNohQfRGQ+V8hVF8DhJcXZRKh+hIgzBU/jCOs83oeb3xhEKFqT4rEWejSIMI66+Rw19k0hLDm++rlvqk5hLtapy43iaYQ1nsNmOe5GUNYdzGn0nlEQwjrr2ZaajBMIVyJjxaoLFxjBqGOUpQtmGgIYf0qLK1EIwj1FKKkEs0grOOwvXU2llDb6pDMqUQjCM+azs8MSRlAmH+rpqZYSyl1T6hzjX1W+NsAQumXSDhidDadE8rneXH1e6qte0K9a3r/nhHumjBbmEGXfmXydUyoeaFkpM/+tFvCJr448zmM6piwiUWMwyJip4Ty7+JVUvFDXV0SajYUb20NIWxwJfH8PEZ3hFBnCTqBZg8wgbDJpdJ7+WTzjgi1BC7K9U6ObpUwNxutksEmpffCyW19yA7pvUKl+upzlZWtLNeQTWIpfgOqrCspqzdiQ98k+qW3rwH3Vr6o8UZcH8JB44reHzaHaUtflM/uaQMpl0y11cm8JVw0owm1+8HcSZUPFukGbO+bKEjBpeVqbNJVK1FjX8wtAezgy9zH9hAB1tpjFlXUu7XE2PYjmNOmDURo7UPHLJV/UE8jYL+TFko1GzbM2EEf+inXaZAxsfKdViBR8IKGGAFuHT6BeXn9JhCT+3bumuyt6Fs3Y8LnNxQyVFSs1TgmfKsWgyQVdfzR9Twm59mYx4cU9TUwovHgq8Evb9cUWsm6FmNy+PJggIHgKDjeQZUSHei39unPGprsVSDRISv9k4JNaXLqQ3VKvOs/P2opzKRLs+i6LgaSSuHgOdy1+FFTnZoP9qvnZ8Qsj5bo/jqaaRmqK/Ci/WK7hg89L5vrIfzrcEUFE28wCMNw4PXMtgdWVlZWVlZWVlZWVlZWVlZWVlZK+g9GVJzXGDVB4gAAAABJRU5ErkJggg==`,
      // addressCallback: "SHOP_PROMOS_CALLBACK",
      // actualDeliverySubsidy: 0, // could be less than the computed deliverySubsidy due to deliveryFee
      deliveryFee: 0, // customer delivery fee
      totalDeliveryFee: 0, // includes tukpay surge
      deliveryFare: null, // store fare object, separate from delivery fee, which could be free
      drivingRoute: null, // store graphhopper response: encoded, distance, pickup, dropoff
      address: null,
      contactlessNote: null, // leave it at the door
      isInit: true,
      loginCheckoutCallback: "SHOP_LOGIN_CHECKOUT_CALLBACK",
      scrolled: false, // set true after first scroll, for logging
      categoryDebounce: false, // if true blocks scroll event from setting category
      categoryTimer: null, // debounce timer
      searchTerm: "", // set by ShopMenuCategories
      showSubmit: false,
      showOptions: false,
      showPreorder: false,
      selectedItem: null, // for options menus component
      clamped: true, // preface clamp 2 lines
      scrollTopPos: 0,
      fulfilmentTime: null,
      cashback: 0,
      promoQuery: null,
      imgFallback: {
        loading: this.$store.state.menuItemPlaceholderPic, //birdProfilePic,
        error: this.$store.state.errorProfilePic,
      },
      pulseAgentMode: false,
      testFleet: "Test Express Delivery",
      z: 0,
    };
  },
  computed: {
    showManualItemEntry() {
      return false;
      // return this.commerce.data.menu || this.userIsCommerceAgent;
    },
    isCrazyCustomer() {
      var crazyCustomers = ["+66933987441"]; // list of crazy customers like Adit
      return crazyCustomers.includes(this.$store.getters.phoneNumber);
    },
    extraDistance() {
      var user = this.$store.state.user;
      if (!user || !user.data.delivery_options) return 0;
      return user.data.delivery_options.extra_distance || 0;
    },
    useGoogle() {
      var user = this.$store.state.user;
      if (!user || !user.data.delivery_options) return false;
      return user.data.delivery_options.use_google;
    },
    multipleLocations() {
      return this.commerce.data.multiple_locations;
    },
    isFreeGiftOrder() {
      return this.basketItems.find((o) => o.item.free_gift);
    },
    freeGiftOver() {
      if (!this.freeGift) return null;
      // return this.commerce.data.free_gift_over;
      return parseInt(this.freeGift.free_gift);
    },
    isPeakHour() {
      var hour = new Date().getHours(); // should get from server based on business tz
      // return [17, 18, 19].includes(hour);
      return [17, 18].includes(hour);
      // return [17].includes(hour);
    },
    isSOL() {
      return this.business.country === "pt";
    },
    isDineInOnly() {
      return this.hasDinein && this.fulfilmentOptions.length === 1;
    },
    showTUKExpress() {
      if (this.isDineInOnly) return false;
      if (this.commerce.data.tuk_express) {
        return !this.commerce.data.tuk_express.hide; // hide: true
      }
      return this.userIsCommerceAgent;
    },
    businessNoteForDriver() {
      if (!this.commerce.data.delivery_options) return null;
      return this.commerce.data.delivery_options.driver_note;
    },
    businessSignName() {
      if (!this.commerce.data.delivery_options) return null;
      return this.commerce.data.delivery_options.sign_name;
    },
    isTestFleet() {
      if (this.commerce.data.test) return true;
      return this.commerce.data.express === "Test Express Delivery";
    },
    isTest() {
      if (this.agentModeData) return this.agentModeData.isTest;
      return false;
    },
    prettyToAddress() {
      var str = this.$t("ride.pin-location");
      if (this.address.address) str = this.address.address;
      if (this.address.name) str = this.address.name + " @ " + str;
      return str;
    },
    shopRegion() {
      return geo.getRegion(this.business);
    },
    isLessPlastic() {
      if (!this.basket.notes) return false;
      return this.basket.notes.includes("No cutlery");
    },
    isContactlessDelivery() {
      return this.contactlessNote;
    },
    lalamoveRequest() {
      return {
        from_address: `${this.business.name} @ ${this.business.address}`,
        from_lat: this.business.lat,
        from_lon: this.business.lon,
        from_name: this.business.name, // shop name
        from_phone: this.lalaFromPhone,
        to_address: this.prettyToAddress,
        to_lat: this.address.lat,
        to_lon: this.address.lon,
        to_name: this.$store.getters.realName || "TUK App Customer",
        to_phone: this.lalaToPhone,
        order_details: this.basketItemsString, //this.lalamoveOrderDetails,
        delivery_notes: this.address.notes, // is this right?
        total_price: this.totalValue || 1, // order value plus delivery fee << forces 0 to 1 for purchase service
        order_prep_time: this.delayedDelivery ? 0 : 10,
        payment_method: this.paymentMethod,
      };
    },
    lalaFromPhone() {
      return this.domesticatePhoneNumber(this.business.data.phone_number);
    },
    lalaToPhone() {
      var customerPhone = this.$store.getters.phoneNumber || "+66909588716";
      return this.domesticatePhoneNumber(customerPhone);
    },
    basketItemsString() {
      var items = "รายการ"; // translate based on business country
      var str = `${this.basketItemCount} ${items}\r\n`;
      this.basket.items.forEach((i) => {
        str = `${str}\r\n${i.quantity} x ${i.item.name}`;
      });
      return str;
    },
    promoCodes() {
      return this.commerce.data.promo_codes;
    },
    takeawayDiscount() {
      return this.commerce.data.takeaway_discount;
    },
    dineinDiscount() {
      return this.commerce.data.dinein_discount;
    },
    fulfilmentDiscount() {
      if (this.isTakeaway && this.takeawayDiscount) return true;
      if (this.isDinein && this.dineinDiscount) return true;
      return false;
    },
    fulfilmentDiscountAmount() {
      if (!this.fulfilmentDiscountPercent) return 0;
      return Math.round(this.fulfilmentDiscountPercent * this.basketValue);
    },
    fulfilmentDiscountPercent() {
      var n = 0;
      if (this.isTakeaway && this.takeawayDiscount) n = this.takeawayDiscount;
      if (this.isDinein && this.dineinDiscount) n = this.dineinDiscount;
      return n / 100.0;
    },
    promoDiscountAmount() {
      return Math.round(0.1 * this.basketValue);
    },
    listView() {
      return this.view === "list";
    },
    showBasketCard() {
      if (!this.basketItemCount) return false;
      if (this.showBasket) return true;
      if (window.innerWidth > 500) return true; // show on wide screen
      return false;
    },
    superuser() {
      return this.isSuperUser();
    },
    showDiscountApplied() {
      return false;
      // return this.basket.items.find((o) => o.item.discount);
    },
    isSafari() {
      return (
        this.$store.getters.isSafari || // safari browser on mobile
        this.$browserDetect.isSafari || // safari browser on mac
        this.isIOSApp()
      );
    },
    youGetXCashback() {
      var amount = `${this.currency}${this.cashback}`;
      return this.$t("promos.you-get-x", { x: amount });
    },
    userIsCommerceAgent() {
      if (this.superuser) return true;
      return this.$store.state.roles.find((r) => {
        return (
          r.role_name === "Commerce Agent" && r.workflow_id === this.commerce.id
        );
      });
    },
    userIsMember() {
      if (this.isMember(this.commerce.business_id)) return true;
      return false;
    },
    // isCNXPromo() {
    //   if (!this.deliveryPromoCode) return false;
    //   return this.deliveryPromoCode.startsWith("tuk");
    // },
    variesTimer() {
      return this.variesTime % 2;
    },
    manualItemPlaceholder() {
      return this.$t("menu.fried-chicken");
    },
    manualPricePlaceholder() {
      return this.$t("price");
    },
    business() {
      return this.$store.state.selectedBusiness;
    },
    currency() {
      return this.currencySymbol(this.business.country);
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    locations() {
      if (!this.commerce) return null;
      return this.commerce.data.locations;
    },
    categories() {
      if (!this.commerce) return null;
      if (!this.commerce.blobs) return null;
      return this.commerce.blobs.find((b) => b.blob_type === "menu_categories");
    },
    optionsMenus() {
      if (!this.commerce) return null;
      if (!this.commerce.blobs) return null;
      return this.commerce.blobs.filter((b) => b.blob_type === "options_menu");
    },
    deliveryTimeOption() {
      return null;
      // return this.optionsMenus.find((m) => m.data.type === "time");
    },
    preface() {
      if (!this.commerce) return null;
      if (!this.commerce.blobs) return null;
      // return this.commerce.blobs.find((b) => b.blob_type === "menu_preface");
      var o = this.commerce.blobs.find((b) => b.blob_type === "menu_preface");
      if (!o) return null;
      return o.data[this.lang] || o.data.preface;
    },
    promos() {
      if (!this.commerce) return false;
      if (!this.commerce.blobs) return false;
      // return this.commerce.blobs.find(b => b.blob_type === "digital_menu");
      var menu = this.commerce.blobs.find(
        (b) => b.blob_type === "digital_menu"
      );
      var sorted = { ...menu }; // shallow copy menu, not sure if this is necessary...
      // move out_of_stock to bottom
      sorted.data.sort((a, b) => {
        if ((a.out_of_stock || false) == (b.out_of_stock || false)) return 0;
        if (a.out_of_stock) return 1;
        return -1;
      });
      return sorted;
      // return menu.data.filter(i => !i.out_of_stock); // could just hide out_of_stock items entirely
    },
    freeGift() {
      return this.items.find(
        (i) => i.free_gift && !i.out_of_stock && !i.hidden
      );
    },
    flashDeals() {
      return this.items.filter((i) => i.flash_deal);
    },
    dineInItems() {
      if (!this.promos) return [];
      var items = this.promos.data; // unfiltered all items, not same as this.items
      return items.filter((i) => i.tags && i.tags.includes("dine-in")); // && i.tags["dine-in"]);
    },
    outOfStockCount() {
      if (!this.promos) return 0;
      var items = this.promos.data;
      return items.filter((i) => i.out_of_stock).length;
    },
    invalidPrices() {
      if (!this.promos) return 0;
      var items = this.promos.data;
      return items.filter(i => this.invalidPrice(i));
    },
    items() {
      if (!this.promos && !this.manualItems) return [];
      if (!this.promos && this.manualItems) return this.manualItems;
      // return this.promos.data.concat(this.manualItems); // combine them
      var items = this.promos.data.concat(this.manualItems); // combined
      // // hide free gift
      // items = items.filter((i) => !i.free_gift);
      // hide items not scheduled for today
      var today = this.$date.getShortDay(); //new Date().toLocaleString("en-US", { weekday: "short" }); // Mon
      items = items.filter((i) => {
        if (!i.schedule || !i.schedule.length) return true;
        return i.schedule.includes(today.toLowerCase());
      });
      // filter for dine-in or other tags
      items = items.filter((i) => {
        if (i.hidden) return false;
        if (!i.tags) return true;
        // if (i.tags.includes("dine-in")) return this.showDineInItems;
        return true; // default
      });
      // filter special time tags *8-10
      items = items.filter((i) => {
        if (!i.tags) return true;
        return this.validTimeTag(i.tags);
      });
      // filter out of stock
      items = items.filter((i) => {
        if (this.hideOutOfStock && i.out_of_stock) return false;
        return true;
      });
      // filter out error items (e.g. missing price or invalid price)
      items = items.filter((i) => {
        if (this.invalidPrice(i)) return false; // check min price with options, allow free gift
        return true;
      })
      // filter for flash deals
      if (this.filterFlashDeals) {
        return (items = items.filter((i) => i.flash_deal));
      }
      if (this.filterMemberItems) {
        return (items = items.filter((i) => this.isMembersOnly(i)));
      }
      // filter for search
      return items.filter((i) =>
        JSON.stringify(i).toLowerCase().includes(this.searchTerm)
      );
    },
    languages() {
      if (!this.commerce) return [];
      return this.commerce.data.languages || ["en", "th"];
    },
    deliveryNotes() {
      if (!this.address) return null;
      return this.address.address;
    },
    orderNotes() {
      if (!this.basket) return null;
      return this.basket.notes;
    },
    basketItems() {
      if (!this.basket) return [];
      return this.basket.items;
    },
    basketItemCount() {
      if (!this.basket) return 0;
      var sum = 0;
      this.basket.items.forEach((o) => {
        sum = sum + o.quantity;
      });
      return sum;
    },
    basketValue() {
      if (!this.basket) return 0;
      var value = 0;
      this.basket.items.forEach((o) => {
        // value = value + o.item.price * o.quantity;
        value = value + this.discountedTotalPrice(o.item) * o.quantity;
      });
      return value;
    },
    vatableBasketValue() {
      if (!this.basket) return 0;
      var value = 0;
      this.basket.items.forEach((o) => {
        if (!o.item.hasOwnProperty("vatable") || o.item.vatable) {
          value = value + this.discountedTotalPrice(o.item) * o.quantity;
        }
      });
      return value;
    },
    totalValue() {
      // need to add all service fees + discounts to total
      var fees = this.vat;
      var discounts = this.fulfilmentDiscountAmount; // + this.specialDiscount;
      var total = this.basketValue + fees - discounts;
      if (!this.isDelivery) return total; // not delivery
      return total + this.actualDeliveryFee; //this.deliveryFee; // if delivery
    },
    totalValueSOL() {
      return this.convertEURtoSOLPretty(this.totalValue);
    },
    basketWarning() {
      if (!this.basket || !this.business) return null;
      if (this.basketItemCount === 0) return null;
      if (this.basket.shop_id !== this.business.id) {
        return `This basket is for another shop.`;
      }
      return null;
    },
    deliveryAddress() {
      return this.$store.getters.deliveryAddress;
    },
    isDelivery() {
      return this.fulfilmentType === "delivery";
    },
    isTakeaway() {
      return this.fulfilmentType === "take-away";
    },
    isDinein() {
      return this.fulfilmentType === "dine-in";
    },
    fulfilmentOptionsString() {
      if (!this.commerce.data.fulfilment_options) return null;
      return this.commerce.data.fulfilment_options
        .map((f) => {
          return this.$t(`commerce.${f}`);
        })
        .join(", ");
    },
    fulfilmentOptions() {
      return this.commerce.data.fulfilment_options || [];
    },
    // these 3 hasXYZ are not being used
    hasDinein() {
      return this.fulfilmentOptions.includes("dine-in");
    },
    hasTakeaway() {
      return this.fulfilmentOptions.includes("take-away");
    },
    hasDelivery() {
      return this.fulfilmentOptions.includes("delivery");
    },
    delayedDelivery() {
      if (this.fulfilmentTime) return true;
      var data = this.commerce.data;
      if (!data.delivery_options) return false;
      return data.delivery_options.type === "delayed";
    },
    delayDuration() {
      var data = this.commerce.data;
      if (!data.delivery_options) return null;
      return data.delivery_options.delay_duration;
    },
    thirdPartyDelivery() {
      var data = this.commerce.data;
      if (!data.delivery_options) return false;
      return data.delivery_options.type === "third-party";
    },
    autoconfirm() {
      var data = this.commerce.data;
      if (!data.order_options) return false;
      return data.order_options.autoconfirm;
    },
    reversedDelivery() {
      if (this.agentModeData) {
        return this.agentModeData.mode === "receive";
      }
      var data = this.commerce.data;
      if (!data.delivery_options) return false;
      return data.delivery_options.reversed;
    },
    extraTukpay() {
      var data = this.commerce.data;
      if (!data.delivery_options) return 0;
      return data.delivery_options.extra_tukpay || 0; // null causes issue
    },
    extraCash() {
      var data = this.commerce.data;
      if (!data.delivery_options) return 0;
      return data.delivery_options.extra_cash || 0; // null causes issue
    },
    deliveryRemit() {
      // sum all the remit amounts related to delivery, not order
      var total = this.fleetRemit + this.customerRemit + this.shopRemit;
      return total || 0;
    },
    // notice I use remit_amount, instead of simpley remit
    // so that later I can add a remit_percent if necessary
    fleetRemit() {
      // maybe call it fleetRemit
      // amount to remit based on fleet for each delivery
      if (!this.deliveryWorkflows) return null;
      if (
        this.deliveryWorkflows.express &&
        this.deliveryWorkflows.express.data.remit_amount
      ) {
        return this.deliveryWorkflows.express.data.remit_amount || 0;
      }
      if (this.deliveryWorkflows.fallback) {
        return this.deliveryWorkflows.fallback.data.remit_amount || 0;
      }
      // or the higher of the two?
      return 0; //null;
    },
    customerRemit() {
      // extra amount for customer to remit per delivery order (add to delivery fee)
      var user = this.$store.state.user;
      if (!user || !user.data || !user.data.delivery_options) return 0;
      return user.data.delivery_options.remit_amount || 0;
    },
    shopRemit() {
      // extra amount for shop to remit per delivery order (add to delivery fee)
      if (!this.commerce.data.delivery_options) return 0;
      return this.commerce.data.delivery_options.remit_amount || 0;
    },
    orderRemit() {
      // amount from order GP to remit (not add to delivery fee, subtract from shop)
      return 0;
    },
    shopDeliveryFee() {
      if (this.tukExpressFreeDelivery) {
        // return this.deliveryFare.cash;
        return this.deliveryFare.client;
      }
      return 0;
    },
    tukExpressFreeDelivery() {
      return this.whoPaysDelivery === "shop"; // this.agentModeData.whoPaysDelivery
    },
    // hasFreeDelivery, not necessarily IS free delivery on this order
    freeDelivery() {
      if (this.tukExpressFreeDelivery) return true;
      if (this.deliverySubsidyPercent) return true;
      if (this.freeDeliveryOver) return true;
      return this.commerce.data.free_delivery;
    },
    dynamicFreeDeliveryOver() {
      if (!this.deliveryFare) return null;
      if (!this.deliverySubsidyPercent) return null;
      // var overAmount = this.deliveryFare.cash / this.deliverySubsidyPercent;
      var overAmount = this.deliveryFare.client / this.deliverySubsidyPercent;
      return Math.ceil(overAmount);
    },
    fixedFreeDeliveryOver() {
      if (!this.deliveryFare) return null;
      var d = this.commerce.data;
      if (!d.free_delivery_over) return null;
      if (!d.free_delivery_distance) return d.free_delivery_over;
      if (this.deliveryFare.distance > d.free_delivery_distance) return null; // too far delivery
      return d.free_delivery_over; // valid delivery distance for fixed free_delivery_over
    },
    freeDeliveryOver() {
      var fixedAmount = this.fixedFreeDeliveryOver; //this.commerce.data.free_delivery_over;
      var dynamicAmount = this.dynamicFreeDeliveryOver;
      if (fixedAmount && dynamicAmount) {
        if (dynamicAmount < fixedAmount) return dynamicAmount;
        return fixedAmount;
      }
      if (dynamicAmount) return dynamicAmount;
      if (this.deliverySubsidyPercent) return null; // if don't know deliveryFare yet
      return fixedAmount;
    },
    freeDeliveryTo() {
      return this.commerce.data.free_delivery_to;
    },
    // check if legacy free delivery
    isLegacyFreeDelivery() {
      if (this.insideFreeDeliveryPolygon()) return true;
      if (!this.freeDeliveryOver) return false; // e.g. null or 0 (put free_delivery_over === -1 for all orders)
      if (this.basketValue >= this.freeDeliveryOver) return true;
      return false;
    },
    isFreeDelivery() {
      if (!this.freeDelivery) return false;
      if (this.tukExpressFreeDelivery) return true;
      if (this.basketValue >= this.freeDeliveryOver) return true;
      // catch edge case where previous if statement not triggered but actually 0 due to rounding
      // if (this.deliveryFee === 0) return true;
      if (this.actualDeliveryFee === 0) return true;
      if (this.insideFreeDeliveryPolygon()) return true;
      return false;
    },
    freeDeliveryRemainder() {
      if (!this.freeDeliveryOver) return null;
      return this.freeDeliveryOver - this.basketValue;
    },
    package() {
      return this.commerce.data.fruit;
    },
    billingAmount() {
      var billingPercent = pricing.billing(this.package);
      if (this.agentModeData) billingPercent = 0;
      // return Math.round(this.basketValue * billingPercent); // should not round this maybe...
      var float = this.basketValue * billingPercent;
      return float.toFixed(2); // need more decimal places? return string "7.00"
    },
    remitAmount() {
      var remitPercent = pricing.remit(this.package);
      if (this.agentModeData) remitPercent = 0;
      var remitAmount = Math.round(this.basketValue * remitPercent);
      if (this.maxRemit && remitAmount > this.maxRemit) {
        return this.maxRemit;
      }
      return remitAmount;
      // var float = this.basketValue * remitPercent; // minus delivery subsidy
      // return float.toFixed(2); // need more decimal places? return string "7.00"
    },
    actualRemitAmount() {
      if (!this.isDelivery) return 0;
      if (!this.remitAmount) return 0;
      var actual = this.remitAmount - this.actualDeliverySubsidy;
      if (actual < 0) return 0; // catch bug where negative remit
      return actual;
    },
    deliverySubsidyPercent() {
      if (this.agentModeData) return 0;
      return pricing.deliverySubsidy(this.package);
    },
    deliverySubsidy() {
      return Math.round(this.basketValue * this.deliverySubsidyPercent);
    },
    actualDeliverySubsidy() {
      if (!this.deliveryFare) return 0;
      if (this.isFreeDelivery) {
        // return this.deliveryFare.cash; // to handle legacy free delivery settings
        return this.deliveryFare.client;
      }
      // if (this.applySpecialDiscount) {
      //   return this.deliverySubsidy;
      // }
      // if (this.deliveryFare.cash < this.deliverySubsidy) {
      //   return this.deliveryFare.cash;
      // }
      if (this.deliveryFare.client < this.deliverySubsidy) {
        return this.deliveryFare.client;
      }
      return this.deliverySubsidy;
    },
    // doesn't account for special free delivery yet
    actualDeliveryFee() {
      if (!this.deliveryFare) return null; // no fare yet
      var cash = this.deliveryFare.client; //this.deliveryFare.cash;
      if (this.isLegacyFreeDelivery) return 0;
      if (this.deliverySubsidy) {
        if (this.deliverySubsidy > cash) return 0;
        else return cash - this.deliverySubsidy;
      }
      return cash;
    },
    specialRemit() {
      if (this.agentModeData || !this.applySpecialRemit) return 0; // tuk express
      if (this.deliveryFare && this.isFreeDelivery) {
        var remit = this.deliverySubsidy - this.deliveryFare.client;
        if (remit < 0) return 0; // should not be negative, e.g. Archers
        if (remit > 30) return 30; // max special remit
        return remit;
      }
      return 0;
    },
    applySpecialRemit() {
      if (!this.package) return false;
      if (this.isLalamove) return false; // lalamove might have edge cases so skip it
      return this.package.startsWith("p_");
    },
    specialDiscount() {
      if (this.agentModeData || !this.applySpecialDiscount) return 0; // tuk express or not
      if (this.deliveryFare && this.isFreeDelivery) {
        // could this be negative like specialRemit was?
        return this.deliverySubsidy - this.deliveryFare.client;
        // if (discount > 0) return discount;
      }
      return 0;
    },
    applySpecialDiscount() {
      if (!this.package) return false;
      return this.package.startsWith("f_");
    },
    deliveryPromoMsg() {
      if (!this.freeDelivery) return null;
      var currency = this.currencySymbol(this.business.country);
      var freeOver = this.$t("delivery.free-delivery-over");
      var freeTo = this.$t("delivery.free-delivery-to");
      if (this.freeDeliveryOver === -1) {
        return this.$t("delivery.free-delivery"); // all orders
      } else if (this.deliverySubsidyPercent) {
        if (this.address) {
          return `${freeOver} ${currency}${this.freeDeliveryOver}`;
        } else {
          return this.$t("delivery.delivery-promo");
        }
      } else if (this.freeDeliveryOver) {
        return `${freeOver} ${currency}${this.freeDeliveryOver}`;
      } else if (this.freeDeliveryTo) {
        return `${freeTo} ${this.freeDeliveryTo}`;
      }
      return null; // user timer to swap free_delivery_to and free_delivery_over if both exist
    },
    freeDeliveryPolygon() {
      return this.commerce.data.free_delivery_polygon;
    },
    maxDeliveryDistance() {
      var arr = [
        this.commerce.data.max_distance,
        this.peakHourMaxDeliveryDistance,
      ];
      if (this.deliveryPricingArray) arr.push(this.deliveryPricingArray.length);
      arr = arr.filter((n) => n); // filter nulls/0s
      if (!arr.length) return 14; // default max distance if none
      return Math.min(...arr); // other max distance is min of all of the above
      // if (
      //   this.commerce.data.max_distance &&
      //   this.peakHourMaxDeliveryDistance &&
      //   this.commerce.data.max_distance < this.peakHourMaxDeliveryDistance
      // ) {
      //   return this.commerce.data.max_distance; // in case shop has set a smaller max_distance than what is allowed by the delivery workflows
      // }
      // if (this.peakHourMaxDeliveryDistance)
      //   return this.peakHourMaxDeliveryDistance;
      // if (this.deliveryPricingArray) return this.deliveryPricingArray.length;
      // return this.commerce.data.max_distance || 14;
    },
    maxDistKM() {
      // just visual to tell customer, actual is above
      // return Math.round((0.7 * this.maxDeliveryDistance) / 1.25);
      return Math.round(0.8 * this.maxDeliveryDistance);
    },
    deliveryFeePerKM() {
      return this.commerce.data.delivery_fee_per_km;
    },
    minDeliveryFee() {
      return this.commerce.data.min_delivery_fee;
    },
    isSelfDelivery() {
      return this.commerce.data.express === "self";
    },
    peakHourMaxDeliveryDistance() {
      if (!this.isPeakHour) return null;
      if (!this.deliveryWorkflows) return null;
      if (this.deliveryWorkflows.fallback) {
        return this.deliveryWorkflows.fallback.data.peak_hour_max_distance;
      }
      if (this.deliveryWorkflows.express) {
        return this.deliveryWorkflows.express.data.peak_hour_max_distance;
      }
      return null;
    },
    deliveryPricingArray() {
      if (!this.deliveryWorkflows) return null;
      if (this.deliveryWorkflows.fallback) {
        return this.deliveryWorkflows.fallback.data.pricing_array;
      }
      if (this.deliveryWorkflows.express) {
        return this.deliveryWorkflows.express.data.pricing_array;
      }
      return null;
    },
    surgeTukpay() {
      // add this to extraTukpay()
      return 0;
    },
    surgeFee() {
      // e.g. raining
      // probably rename to surge_cash
      if (!this.deliveryWorkflows) return 0;
      if (this.deliveryWorkflows.fallback) {
        return this.deliveryWorkflows.fallback.data.surge || 0;
      }
      if (this.deliveryWorkflows.express) {
        return this.deliveryWorkflows.express.data.surge || 0;
      }
      return 0;
    },
    fallbackFleet() {
      return this.commerce.data.fallback_fleet;
    },
    isLalamove() {
      // if (!this.commerce.data.express) return false;
      var express = this.commerce.data.express || "";
      var fallback = this.commerce.data.fallback_fleet || "";
      // return this.commerce.data.express.startsWith("Lalamove"); // or this.fallbackFleet === "Lalamove"
      return express.startsWith("Lalamove") || fallback.startsWith("Lalamove");
    },
    maxRemit() {
      return this.commerce.data.max_remit; // temporary setting for Gulf large order
    },
    minOrder() {
      return this.commerce.data.min_order;
    },
    minOrderText() {
      var minOrder = this.$t("menu.minimum-order");
      return `${minOrder} ${this.currency}${this.minOrder}`;
    },
    fulfilmentClass() {
      if (this.isDelivery) return "fa-shipping-fast";
      if (this.isTakeaway) return "fa-walking";
      if (this.isDinein) return "fa-users";
      return null;
    },
    fulfilmentText() {
      if (this.isDelivery) return this.$t("commerce.delivery");
      if (this.isTakeaway) return this.$t("commerce.take-away");
      if (this.isDinein) return this.$t("commerce.dine-in");
      return null;
    },
    addressName() {
      if (!this.address) return null;
      if (!this.address.name || this.address.name === "") {
        return this.$t("ride.pin-location");
      }
      return this.address.name;
    },
    closedUntil() {
      if (!this.commerce.data.closed_until) return null;
      return this.isFutureTime(this.commerce.data.closed_until);
    },
    isPaused() {
      return this.commerce.data.paused;
    },
    isBlocked() {
      return this.commerce.data.blocked;
    },
    isOpen() {
      // also check business.is_deleted?
      if (this.isPaused) return false;
      if (this.isBlocked) return false;
      if (this.closedUntil) return false;
      if (this.business.data.hours_type === "always-open") return true;
      if (!this.business.data.hours) return true; // unknown hours, say open
      var today = this.$date.getShortDay(); //new Date().toLocaleString("en-US", { weekday: "short" });
      var hours = this.business.data.hours[today.toLowerCase()];
      if (hours && this.openNow(hours)) return true;
      return false;
    },
    hoursAlwaysOpen() {
      if (!this.business.data.hours_type) return true;
      if (this.business.data.hours_type === "always-open") return true;
      return false;
    },
    todaysHours() {
      if (this.closedUntil) return this.$t("commerce.on-holiday");
      if (this.hoursAlwaysOpen) return this.$t("always-open");
      var today = this.$date.getShortDay(); //new Date().toLocaleString("en-US", { weekday: "short" }); //  timeZone: "America/New_York",
      if (!this.business.data.hours) return this.$t("always-open"); // unknown hours, say open
      var hours = this.business.data.hours[today.toLowerCase()];
      return hours || "Closed";
    },
    shopClosedMsg() {
      // old way, now deprecated for top banner thing
      var todaysHoursTxt = this.$t("shop.todays-hours");
      return `This shop is currently closed. 🕤<br>Submit order when shop is open.<br>${todaysHoursTxt}: ${this.todaysHours}`;
    },
    specialItems() {
      return this.items.filter((i) => i.special && !i.out_of_stock);
    },
    showMembersOnlyWall() {
      if (!this.commerce || !this.commerce.data.members_only) return false;
      return !this.isMember(this.business.id); // should check if this user has a member role
    },
    vat() {
      if (this.agentModeData) return 0;
      if (!this.commerce || !this.commerce.data.vat) return 0;
      // probably use basketValue - discounts for VAT calculation?
      return Math.round(this.commerce.data.vat * this.vatableBasketValue); //this.basketValue);
    },
    vatPercent() {
      if (!this.commerce || !this.commerce.data.vat) return 0;
      return this.commerce.data.vat;
    },
    billingPercent() {
      if (this.agentModeData) return 0;
      if (!this.isDelivery) return 0;
      return pricing.billing(this.package);
    },
    remitPercent() {
      if (this.agentModeData) return 0;
      if (!this.isDelivery) return 0;
      return pricing.remit(this.package);
    },
    requiresLargeBox() {
      // does the delivery require a large box? e.g. Pizza
      if (
        this.basket.items.find((o) =>
          JSON.stringify(o).toLowerCase().includes("pizza")
        )
      )
        return true;
      return false;
    },
  },
  mounted() {
    console.log("mounted ShopPromosTab");
    setInterval(() => {
      this.variesTime += 1;
    }, 2500);
    EventBus.$on(this.loginCheckoutCallback, () => {
      this.preSubmit();
    });
    if (this.$route.path.startsWith("/express/")) {
      this.showAgentModeWall = true;
    }
    setTimeout(() => {
      if (this.showAgentModeWall) this.$emit("scrolled");
    }, 500);
    // EventBus.$on(this.addressCallback, (data) => {
    //   this.setDeliveryAddress(data);
    // });
    setTimeout(() => {
      this.checkForMenuAnomalies();
    }, 5000)
  },
  beforeDestroy() {
    // EventBus.$off(this.addressCallback);
    EventBus.$off(this.loginCheckoutCallback);
  },
  activated() {
    console.log("activated ShopPromosTab");
    this.showHowTo = false;
    this.showBasket = false;
    this.fulfilmentType = null;
    this.initBasket();
    this.z += 1;
  },
  methods: {
    handleBackButton() {
      if (!(this.showBasket || this.showOptions)) return false; // nothing to handle, let ShopProfile view navigate away
      if (this.showOptions) this.showOptions = false;
      else if (this.showSubmit) this.showSubmit = false;
      else if (this.showBasket) this.showBasket = false;
      return true; // otherwise ShopProfile won't navigate away
    },
    showInvalidPrices() {
      var msg = `<div style='text-align:left'>`
      this.invalidPrices.forEach(i => {
        msg += `<p>${i.name}: <b>${i.price}</b></p>`
      })
      msg += `</div>`
      this.errorToast(msg, "bottom", 9000)
    },
    checkForMenuAnomalies() {
      // // check if shop doesn't have any items
      // var shop = this.business.name;
      // if (!this.items.length) {
      //   // let msg = `📖 No menu items @ ${shop}`;
      //   // this.sendSuperuserNotification(msg);
      //   // console.log("items length", this.items.length)
      //   return
      // }
      // // check for menu items with fishy prices
      // var countBadPrices = this.items.filter(i => i.price < 9).length;
      // if (countBadPrices) {
      //   let msg = `📖 ${countBadPrices} bad prices @ ${shop}`;
      //   this.sendSuperuserNotification(msg);
      //   console.log("bad prices", countBadPrices)
      //   return
      // }
    },
    showFreeGift() {
      // this.triggerOptions(this.freeGift);
      this.addToBasket(this.freeGift, true);
    },
    promptFreeGiftOverRemoval() {
      var freeGiftOver = this.currency + this.freeGiftOver;
      var basketValue = this.currency + this.basketValue;
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-gift fa-sm'></i>&nbsp;Free Gift over ${freeGiftOver}</p>
        <p style='margin-bottom:10px'>Currently your order basket value is:</p>
        <p style='margin-bottom:10px'><b>${basketValue}</b></p>
        <p>You can add more to your basket to qualify for the Free Gift.</p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: "Remove Free Gift",
      }).then((val) => {
        if (val.value) {
          this.minimise();
          return;
        }
        if (val.dismiss === "cancel") {
          // this.errorToast("Remove free gift");
          this.removeFromBasket(this.freeGift);
        }
      });
    },
    isMembersOnly(o) {
      if (!o.tags) return false;
      return o.tags.includes("member");
    },
    viewMemberDeals() {
      this.filterMemberItems = !this.filterMemberItems;
    },
    setMenuLanguage(l) {
      if (this.languages.length === 1) {
        this.errorToast("This shop's menu has<br>only 1 language", "top");
        this.log("menu_only_1_lang", l);
        return;
      }
      this.lang = l;
      this.log("set_menu_lang", l);
    },
    longPrepTime(item) {
      return item.prep_time > 20;
    },
    testOrderInfo() {
      var msg = `This shop is in TEST mode<br>Contact us to go LIVE.`;
      this.errorToast(msg, "top", 9000);
    },
    viewLocations() {
      this.goto(`/search/${this.multipleLocations}`);
    },
    editGiftDetails() {
      var placeholder = null;
      if (this.giftDetails) placeholder = this.giftDetails.recipient_phone;
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-gift'></i>&nbsp;Gift Recipient Details
        </p>
        <p style='margin-bottom:10px'>Enter the phone number of the recipient.</p>
        <p>Please remember tell the recipient to expect the delivery at the address you provided.</p>
        </div>`,
        input: "number",
        inputValue: placeholder,
        showCloseButton: true,
        showCancelButton: true,
        inputValidator: (val) => {
          if (val.length < 8) return "Enter a valid phone number";
        },
      }).then((val) => {
        if (val.value) {
          this.giftDetails = { recipient_phone: val.value };
        }
        if (val.dismiss === "cancel") this.giftDetails = null;
      });
    },
    validTimeTag(tags) {
      // given an item's tags check if has a time tag like *9-13
      console.log("validTimeTag", tags);
      var timeTag = tags.find((t) => t.startsWith("*"));
      if (!timeTag) return true;
      var times = timeTag.replace("*", "").split("-");
      if (times.length !== 2) return true;
      console.log("times", times[0], times[1]);
      var h = new Date().getHours(); // local time hour
      return h >= parseInt(times[0]) && h < parseInt(times[1]);
    },
    domesticatePhoneNumber(str) {
      if (!str || str.length < 8) return; // shouldn't happen
      return str.replace("+66", "0").trim(); // assume thai number only
    },
    openPreorder() {
      console.log("delivery time option", this.deliveryTimeOption);
      this.showPreorder = true;
    },
    deliveryBreakdown() {
      if (!this.$store.getters.isSuperUser) return;
      var f = this.deliveryFare;
      var msg = `<div style='text-align:left; color:black; font-size:1.2em'>
      <span style='font-weight:550'>Delivery Breakdown</span>
      <br>distance ${f.distance} ${this.drivingRoute ? "***" : "!!!"}
      <br>remit ${f.remit}
      <br>client ${f.client}
      <br>price ${f.price}
      <br>cash ${f.cash}
      <br>tukpay ${f.tukpay}
      <br>surge ${this.surgeFee}
      <br>bonus ${f.bonus}
      <br>subsidy ${this.deliverySubsidy} (${this.actualDeliverySubsidy})
      <br>fee ${this.deliveryFee}
      <br>actual ${this.actualDeliveryFee}
      <br>plan ${this.package} (free over ${this.freeDeliveryOver})</div>`;
      this.infoToast(msg, "top", 30000);
    },
    handleFulfilmentDiscountClick() {
      if (this.basketItemCount) this.showBasket = true;
      else this.fulfilmentType = null;
    },
    toggleFlashDealFilter() {
      this.filterFlashDeals = !this.filterFlashDeals;
    },
    reInit() {
      // called whenever this this tab is shown
      this.showBasket = false; // close basket if it was open
      this.initBasket(); // doesn't work when switching back to basket shop
      // this.isInit = true;
      // setTimeout(() => (this.isInit = false), 500);
      if (this.showMembersOnlyWall) {
        this.updateRoles(false);
        this.$refs.wall.triggerWall();
      }
      this.handleVisualDiscount();
      setTimeout(() => (this.showPreface = false), 6000);
      // this.checkDeliveryAddress();
    },
    checkDeliveryAddress() {
      if (this.$store.getters.getDeliveryAddress) {
        var likelyAddress = this.$store.getters.getDeliveryAddress;
        // should compute delivery fare here
        var dist = this.tripDistance(likelyAddress, this.business);
        this.infoToast("Est. delivery distance: " + dist);
      } else {
        // ask user if this is a delivery, take-away or dine-in
      }
    },
    clearSearch() {
      this.$refs.categories.clearSearch();
    },
    gotoCat(cat) {
      console.log("gotoCat", cat, this.$refs.categories, this.$refs);
      if (this.$refs.categories) {
        this.$refs.categories.chooseCategory(cat);
      }
      //  else {
      //   setTimeout(() => this.gotoCat(cat), 5000);
      // }
    },
    showDeliveryPricingArray() {
      if (!this.isSuperUser()) return; // secret shhhh
      var msg = "<div style='text-align:left'>";
      if (this.deliveryPricingArray) {
        var str = this.deliveryPricingArray.join(", ");
        msg += `Delivery Pricing Array:<br>${str}`;
      } else {
        msg += `Old Delivery Pricing Model`;
      }
      if (this.surgeFee) msg += `<br>SURGE ON: ${this.surgeFee}`;
      else msg += "<br>Surge OFF";
      if (this.extraTukpay) msg += `<br>Extra Tukpay: ${this.extraTukpay}`;
      if (this.extraCash) msg += `<br>Extra Cash: ${this.extraCash}`;
      // if (this.deliveryRemit)
      msg += `<br>Delivery Remit: ${this.deliveryRemit}`;
      msg += "</div>";
      this.infoToast(msg, "top", 20000);
    },
    triggerAgentMode() {
      console.log("TriggerAgentMode");
      this.showAgentModeWall = true;
    },
    setAgentMode(data) {
      this.newBasket(); // make new basket in case they had one already
      this.agentModeData = data;
      this.fulfilmentType = "delivery"; // assume delivery is set up for this shop
      this.openSetAddressModal(); // set address now...
      //  <i class='fa fa-map-marker-alt'></i>&nbsp;Set delivery address
      //  Enter the customer's address for the delivery.
      // Your shop's address has been automatically set as the order pickup location.
      // *If you are unsure of the exact location put a nearby landmark. The driver can call the customer for directions.
    },
    tukExpressPlaceOrder(data) {
      console.log("tukExpressPlaceOrder", data);
      // this.showAgentModeWall = false;
      this.newBasket(); // make new basket in case they had one already, probably don't do this here
      this.agentModeData = data;
      this.fulfilmentType = "delivery"; // assume delivery is set up for this shop

      // this.setAgentModeOptions(data); << old way...
      this.address.notes = data.addressNotes;
      this.whoPaysDelivery = data.whoPaysDelivery;
      if (data.goods) {
        // data.goods if not null is an array of objects
        data.goods.forEach((item) => {
          var manualItem = {
            id: "~" + shortid.generate(), // needs a random ID, start with ~
            name: item.name,
            price: item.price,
          };
          if (data.payment === "shop") {
            manualItem.price = 0;
            manualItem.actual_price = item.price;
          }
          // this.addToBasket(manualItem, true);
          this.manualItems.push(manualItem); // needed to show on order page
          this.basket.items.push({ item: manualItem, quantity: 1 });
        });
        this.basket.notes = "[🛵 TUK Express Order] " + data.orderNotes;
        this.saveBasket();
        this.updateDeliveryFee();
      } else {
        // later if this is emtpy it means use the existing basket
        alert("data.goods should not be empty for now");
        return;
      }
      this.preSubmit();
    },
    setAgentModeOptions(data) {
      console.log("setAgentModeOptions", data);
      this.showAgentModeOptions = false;
      this.whoPaysDelivery = data.whoPaysDelivery;
      if (data.costOfGoods) {
        this.newBasket(); // new basket in case had stuff before
        var manualItem = {
          id: "~" + shortid.generate(), // needs a random ID, start with ~
          name: "Goods",
          price: data.costOfGoods,
          // description: "จากเมนู (From menu)",
        };
        // this.addToBasket(manualItem, true);
        this.manualItems.push(manualItem); // needed to show on order page
        this.basket.items.push({ item: manualItem, quantity: 1 });
        this.saveBasket();
        this.updateDeliveryFee();
        this.preSubmit();
      } else {
        // normal order flow
        this.showBasket = false;
        this.triggerPulseAgentMode();
        this.triggerAgentModeOrderHelp();
      }
    },
    setPromo(code) {
      this.promoQuery = code;
    },
    hasOptions(o) {
      return o.item.options && o.item.options.length; // used in table
    },
    invalidPrice(item) {
      // should check min price (after discounts) with options, allow free gift
      return (item.price < 9 && !(this.hasOptions({ item: item })) && !item.free_gift);
    },
    togglePics() {
      this.showPics = !this.showPics;
    },
    scrollToTop() {
      this.$refs.scrollable.scrollTo({ top: 0, behavior: "smooth" });
    },
    scrollToBottom() {
      // used by Agent Mode "Add Special Menu Item" button
      this.$refs.scrollable.scrollTo({ top: 9999, behavior: "smooth" });
      this.triggerPulseAgentMode();
    },
    triggerPulseAgentMode() {
      setTimeout(() => (this.pulseAgentMode = true), 500);
      setTimeout(() => (this.pulseAgentMode = false), 6500);
    },
    handleVisualDiscount() {
      if (!this.promos) return;
      var visualDiscount = this.commerce.data.visual_discount;
      if (!visualDiscount) return;
      var percent = visualDiscount * 100; // .20 -> 20%
      this.promos.data.forEach((i) => {
        i.discount = Math.round(parseInt(i.discount || 0) + percent); // increase the discount by x
        // var visualIncrease = parseFloat(i.price * visualDiscount);
        // i.price = Math.round(parseFloat(i.price) + visualIncrease); // increase the price
        i.price = Math.round(parseFloat(i.price) / (1 - visualDiscount));
      });
      this.z += 1;
    },
    closeSetAddress() {
      this.showSetAddress = false;
      if (!this.address) {
        this.showBasket = false; // in case it was true, to escape the map
        this.fulfilmentType = null;
      }
    },
    setDeliveryAddress(data) {
      this.log("set_delivery_address", data);
      this.triggerPulseAgentMode();
      this.lalamoveQuote = null; // clear this on new address
      this.deliveryFare = null; // also clear this
      this.drivingRoute = null; // 26 June 2021
      this.address = data; // if invalid address will be set to null below
      this.getDrivingRoute(); // get driving route and distance to pass to setDeliveryFare
      // this.setDeliveryFare(); // sets this.deliveryFare or calls lalamove to set async
      // if (!this.deliveryFare) return; // not set means it was invalid or async
      // this.updateDeliveryFee(); // handles free delivery and delivery subsidy
      // this.finishSetDeliveryAddress();
    },
    // for minimart, mcdonalds use closest
    closestPickupLocation() {
      if (!this.locations) return this.business;
      this.locations.forEach((l) => {
        l.distance = geo.distanceToUserInMeters(l, this.address);
      });
      this.locations.sort((a, b) => {
        return a.distance - b.distance;
      });
      return this.locations[0]; // console.log("sorted locations", this.locations);
    },
    getDrivingRoute() {
      var obj = {
        pickup: this.closestPickupLocation(), //this.business,
        dropoff: this.address,
      };
      // var routeData = null; //
      var loader = this.loadingDots("orange");
      this.$store
        .dispatch("drivingRoute", obj)
        .then((data) => {
          console.log("drivingRoute", data);
          this.drivingRoute = data;
          if (this.extraDistance) {
            this.drivingRoute.distance += this.extraDistance;
          }
        })
        .catch((err) => {
          obj.err = err;
          this.log("get_driving_route_error", obj);
          var msg = `🚦 Using fallback distance`;
          if (this.$store.getters.isSuperUser) this.errorToast(msg);
          var name = this.$store.getters.getNameAndNumber;
          var shop = this.business.name;
          msg += `[ ${name} @ ${shop} ]`;
          this.sendSuperuserNotification(msg);
        })
        .finally(() => {
          loader.hide();
          this.setDeliveryFare(); // sets this.deliveryFare or calls lalamove to set async
          if (!this.deliveryFare) return; // not set means it was invalid or async
          this.updateDeliveryFee(); // handles free delivery and delivery subsidy
          this.finishSetDeliveryAddress();
        });
    },
    finishSetDeliveryAddress() {
      if (this.isFreeDelivery && this.deliveryFare && this.deliveryFare.price) {
        var msg = this.$t("menu.you-get-free-delivery");
        this.successToast(msg);
      }
      if (this.userID()) this.saveDeliveryAddress(this.address);
      // this.openFulfilmentTimeSelector();
      if (this.agentModeData) this.showAgentModeWall = true; // open tuk express to finish
      this.checkout();
    },
    triggerAgentModeOrderHelp() {
      var blue = this.bulmaColor("link");
      this.$swal({
        html: `<div style='text-align:left'> 
        <p style='margin-bottom:12px; font-size:1.1em'><i class='fa fa-shopping-cart'></i>&nbsp;Select customer's order</p>
        <p style='margin-bottom:10px'>Add normal items from the menu.</p>
        <p style='margin-bottom:10px'>Or manually enter anything.</p>
        <p style='margin-bottom:10px; font-size:0.8em'>
        <i>Just give each line item a name and price. 
        <br>Click on</i>&nbsp;
          <a style='color:${blue}'><i class='fa fa-plus-circle'></i>&nbsp;Add Items</a>
        </p>
        </div>`,
        showCloseButton: true,
      }).then(() => this.triggerPulseAgentMode());
    },
    optionMenuName(o) {
      var menu = o.menu.name;
      if (o.menu[this.lang]) menu = o.menu[this.lang];
      return menu;
    },
    optionItemName(o) {
      var option = o.option.name;
      if (o.option[this.lang]) option = o.option[this.lang].name;
      return option;
    },
    clearFulfilmentType() {
      this.fulfilmentType = null;
      this.showDineInItems = false;
    },
    setDineIn(bool) {
      this.showDineInItems = bool;
      if (bool) this.fulfilmentType = "dine-in";
      else this.fulfilmentType = null;
    },
    prettyOptions(options) {
      return options
        .map((o) => {
          var menu = o.menu.name;
          if (o.menu[this.lang]) menu = o.menu[this.lang];
          var option = o.option.name;
          if (o.option[this.lang]) option = o.option[this.lang].name;
          return `${menu}: ${option}`;
        })
        .join(", ");
    },
    messageBusiness() {
      this.log("send_menu_suggestion", "open");
      var blue = this.bulmaColor("link");
      this.$swal({
        // title: `<i class='far fa-comment' style='color:${blue}'></i>`,
        html: `
        <div style='text-align:left'>
        <p style='font-size:1.2em'><i class='far fa-comment-dots'></i>&nbsp;Menu Suggestion</p>
        <p style='margin-top:12px'>Please enter your suggestion.</p>
        <p style='margin-top:10px; font-size:0.85em; opacity:0.8'>
        <i>*If this comment is about your order please write it in your checkout basket.</i>
        </p>
        </div>`,
        input: "textarea",
        showCloseButton: true,
        showCancelButton: false,
        confirmButtonText: this.$t("menu.submit-menu-suggestion"),
        confirmButtonColor: blue,
      }).then((val) => {
        if (!val.value) return;
        this.thankYou("We appreciate your suggestions and feedback.");
        // this.sendSuperuserNotification(val.value);
        this.sendEmail(val.value);
      });
    },
    sendEmail(comment) {
      var obj = {
        type: "menu_suggestion",
        shop_name: this.business.name,
        comment: comment,
        uuid: this.$store.getters.getUUID,
        mobile: this.$store.getters.phoneNumber,
        name: this.$store.getters.realName,
        app: process.env.VUE_APP_TITLE,
      };
      if (this.$store.getters.isLoggedIn) {
        obj.user_id = this.$store.state.user.id;
      }
      this.$store
        .dispatch("sendEmail", obj)
        .then((res) => this.console(res))
        .catch((err) => console.error(err));
    },
    showCurrentBasketValue() {
      var msg = `Current basket value is ${this.currency}${this.basketValue}`;
      this.infoToast(msg, "top");
    },
    enterPromoCode() {
      if (this.shopRegion !== "Chiang Mai") {
        this.infoToast("Promo codes unavailable in your region");
        return;
      }
      this.log("commerce_delivery_promo_code", "open");
      var blue = this.bulmaColor("info");
      var text = this.$t("promos.enter-promo-code");
      this.$swal({
        html: `<div style='text-align: left'>
        <p style='font-size:1.2em'>
        <i class='fa fa-gift'></i>&nbsp;${text}</p>
        </div>`,
        // <p style="margin-top:10px"><i>Hint: if you can't remember use <i style='font-weight:550'>FREE4</i></i></p>
        // animation: true,
        input: "text",
        inputValue: this.deliveryPromoCode,
        showCloseButton: true,
        showCancelButton: false,
        confirmButtonText: this.$t("submit"),
        confirmButtonColor: blue,
      }).then((val) => {
        if (!val.value) return;
        this.deliveryPromoCode = null; // clear in case was set
        var txt = val.value.toLowerCase();
        this.log("commerce_delivery_promo_code", txt);
        // if (txt === "free4") {
        //   this.deliveryPromoCode = txt;
        //   this.handleFreeDeliveryPromo(txt);
        //   return;
        // }
        // if (txt.startsWith("tuk")) {
        //   this.deliveryPromoCode = txt;
        //   this.handleCashbackPromo(txt);
        //   return;
        // }
        if (txt.startsWith("+")) {
          this.deliveryPromoCode = txt;
          return;
        }
        if (codes.lookup(txt)) {
          this.deliveryPromoCode = codes.lookup(txt);
          return;
        }
        if (txt === "smash") {
          this.deliveryPromoCode = txt;
          return;
        }
        this.errorToast("Invalid or expired promo code", "bottom");
      });
    },
    showCNXPromoInfo() {
      var title = this.$t("promos.songkran-title");
      // Get ฿100 cashback on ฿1000 order
      var text1 = this.$t("promos.songkran-text", { x: "  ฿50", y: "   ฿500" });
      var text2 = this.$t("promos.songkran-text", { x: "฿100", y: "฿1000" });
      var text3 = this.$t("promos.songkran-text", { x: "฿200", y: "฿2000" });
      var text4 = this.$t("promos.songkran-text", { x: "฿300", y: "฿3000" });
      var hint = this.$t("promos.songkran-hint");
      this.$swal({
        html: `<div style='text-align: left'>
        <p style="font-size:1.2em">🎉 ${title}</p>
        <p style="margin-top:10px">${text1}</p>
        <p>${text2}</p>
        <p>${text3}</p>
        <p>${text4}</p>
        <p style="margin-top:10px; font-size:0.9em; font-weight:500; opacity:0.7">
          <i>${hint}</i>
        </p>
        </div>`,
        animation: true,
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
        // confirmButtonText: "Give me cashback",
        // confirmButtonColor: this.bulmaColor("success"),
      });
    },
    // checkFree4Promo() {
    //   var opts = { hour: "2-digit", hour12: false, timeZone: "Asia/Bangkok" };
    //   var hour = parseInt(new Date().toLocaleString("en-GB", opts));
    //   console.log("hour", hour);
    //   if (hour >= 13 && hour <= 21 && this.deliveryFare.distance < 4000) {
    //     this.deliveryPromoCode = "FREE4";
    //     this.successToast("You get free delivery!");
    //     return true;
    //   }
    //   this.deliveryPromoCode = null; // reset
    //   var msg = `This promo is only valid for deliveries up to 4km between the hours of 1400-2159`;
    //   this.warningAlert(msg);
    //   return false;
    // },
    minimise() {
      console.log("hide basket");
      this.log("minimise_basket");
      this.showBasket = false;
    },
    toggleBasket() {
      if (this.showBasket) this.minimise();
      else this.checkout();
    },
    checkout() {
      this.log("checkout_basket");
      if (this.invalidBasketForShop()) return;
      this.initBasket();
      if (!this.basketItems.length) return;
      console.log("show basket");
      this.showBasket = true;
    },
    setFulfilmentType(type) {
      this.fulfilmentType = type;
      if (type === "delivery") this.openSetAddressModal();
      else this.openFulfilmentTimeSelector();
    },
    previousCategory(items, i) {
      if (i === 0) return "first";
      if (items[i - 1].out_of_stock) return "Out of Stock";
      return items[i - 1].category; // actual category of previous item
    },
    onSearchEnter() {
      var el = this.$refs.scrollable;
      el.scrollTo({ top: 56, behavior: "smooth" });
    },
    onSearchMenu(txt) {
      this.searchTerm = txt;
      // scroll top? use onSearchEnter()
      // if searchParam set in URL then open it, should change to product ID
      // instead of search, for url search param
      this.$nextTick(() => {
        if (this.items.length === 1) {
          this.search = null; // clear it
          var id = this.items[0].id;
          this.$refs[id][0].clickItem();
        }
      });
    },
    // deprecated, now using props
    setSearchFromParent(txt) {
      this.$refs.categories.setSearchFromParent(txt);
    },
    cleanCat(cat) {
      if (!cat) return cat;
      return cat.replace(/'/g, "");
    },
    onSetCategory(cat) {
      if (cat === "Specials") this.filterMemberItems = false;
      clearTimeout(this.categoryTimer);
      this.categoryDebounce = true;
      this.categoryTimer = setTimeout(
        () => (this.categoryDebounce = false),
        2000
      );
      var el = this.$refs.scrollable;
      if (cat === "Specials") {
        return el.scrollTo({ top: 0, behavior: "smooth" });
      }
      var cleaned = this.cleanCat(cat);
      var items = this.$el.querySelectorAll(`[data-category='${cleaned}']`);
      if (!items.length) {
        if (this.superuser) this.warningToast(`No items in category<br>${cat}`); // no items with this category...
        return;
      }
      var pos = items[0].offsetTop - this.offsetTopAdjustment(); //47; // android
      el.scrollTo({ top: pos, behavior: "smooth" });
    },
    offsetTopAdjustment() {
      if (this.isSafari) return 305;
      return 47; // default value is for android
    },
    gotoInfo() {
      this.$emit("gotoInfoTab"); // should open the map to see the free delivery polygon
    },
    toggleHowTo() {
      if (!this.showHowTo) this.log("opened_menu_info");
      // 19 June 2021, also use this to toggle preface
      this.showHowTo = this.showPreface; // first need to sync them in case they were not same
      this.showPreface = !this.showPreface;
      this.showHowTo = !this.showHowTo;
    },
    insideFreeDeliveryPolygon() {
      if (!this.freeDeliveryPolygon) return false;
      if (!this.address) return false;
      var gju = require("geojson-utils");
      var lat = this.address.lat;
      var lon = this.address.lon;
      var point = { type: "Point", coordinates: [lon, lat] };
      var polygon = { type: "Polygon", coordinates: this.freeDeliveryPolygon };
      if (gju.pointInPolygon(point, polygon)) {
        return true;
      }
      return false;
    },
    saveDeliveryAddress(data) {
      // only save address if user is logged in
      var address = {
        name: data.name,
        address: data.address,
        lat: data.lat,
        lon: data.lon,
        address_type: "delivery",
        notes: data.notes,
        user_id: this.userID(),
      };
      this.console("saveAddress", address);
      // var loader = this.loadingDots("navy");
      this.$store
        .dispatch("saveUserAddress", address)
        .catch((err) => this.apiError(err));
      // .finally(() => loader.hide());
    },
    // blur() { document.activeElement.blur(); },
    openSetAddressModal() {
      this.setAddressInitialised = true;
      this.showSetAddress = true;
      this.$nextTick(() => this.$refs.setDeliveryAddress.reset());
      this.fulfilmentType = "delivery"; // in case was not set yet
      this.showDineInItems = false; // turn this off
      // maybe pass in optional country code or business coordinates
      // EventBus.$emit("SET_ADDRESS_MODAL", this.addressCallback);
      document.activeElement.blur(); // closes any browser form suggestion, could make a general blur() func for use everywhere
      this.deliveryPromoCode = null; // reset any delivery promo code in case address change
    },
    openFulfilmentTimeSelector() {
      // check if necessary first
      this.showTimeSelector = true;
    },
    addItemsHint() {
      this.initBasket(); // a hack...
      var green = this.bulmaColor("primary");
      this.$swal({
        title: `<i class='fa fa-shopping-basket'></i>`,
        html: `Click the <i class='fa fa-plus-circle fa-lg' style='padding:4px; color:${green}'></i> 
                button next to an item to add it to your basket.`,
        showCloseButton: true,
        showConfirmButton: false,
      });
    },
    specialStyle(item) {
      if (item.id && item.id.startsWith("~")) return `background-color:azure`;
      return null;
    },
    // triggers on scroll
    closeBasketAndHowTo() {
      // console.log("close basket and howTo");
      if (this.$refs.scrollable) {
        this.scrollTopPos = this.$refs.scrollable.scrollTop;
      }
      // this.showBasket = false;
      this.showHowTo = false;
      this.menuScroll();
      this.$emit("scrolled");
    },
    menuScroll() {
      if (this.categories) this.checkCategoryOnScroll();
      if (this.scrolled) return; // only log the first one
      this.scrolled = true;
      this.log("menu_scroll");
    },
    checkCategoryOnScroll() {
      if (this.categoryDebounce) return;
      if (!this.$refs.categories || !this.$refs.categories.$el) return;
      var y = this.$refs.categories.$el.getBoundingClientRect().bottom;
      this.$el.querySelectorAll(".cat").forEach((el) => {
        var rect = el.getBoundingClientRect();
        if (rect.top < y && rect.bottom > y) {
          var current = el.getAttribute("data-category");
          this.$refs.categories.setCategory(current);
        }
      });
    },
    validFareDistance(distance) {
      var name = `${this.$store.getters.realName} ${this.$store.getters.phoneNumber}`;
      var shop = this.business.name;
      if (distance <= 50) {
        let weird = `🦦 Too short delivery ${distance}m 🤹🏼‍♂️${name} @ ${shop}`;
        this.sendSuperuserNotification(weird); // blocked
        var tooClose = `Please enter a valid delivery address.<br><br>The address you gave is the same as the shop.`;
        this.warningAlert(tooClose);
        this.fulfilmentType = null;
        this.deliveryFare = null;
        this.address = null;
        return false;
      }
      // if (distance < 800) {
      //   var weird = `🦦 Weird delivery distance ${distance}m 🤹🏼‍♂️${name} @ ${shop}`;
      //   this.sendSuperuserNotification(weird); // okay, just a bit odd
      // }
      if (distance > this.maxDeliveryDistance * 1000) {
        console.log("delivery distance", distance);
        let km = Math.round(distance / 1000);
        let far = `🐆 Too far delivery ${km}km 🤦🏻‍♂️${name} @ ${shop}`;
        if (!this.isCrazyCustomer) this.sendSuperuserNotification(far); // blocked, don't spam super if Adit
        this.deliveryTooFarAlert();
        this.fulfilmentType = null;
        this.deliveryFare = null;
        this.address = null;
        return false;
      }
      // console.log("validFareDistance", this.maxDeliveryDistance, distance);
      return true;
    },
    setDeliveryFare() {
      var fare = this.getFare(this.business, this.address);
      if (!this.validFareDistance(fare.distance)) return;
      this.deliveryFare = fare;
      if (this.isLalamove) this.getFareFromLalamove(fare); // this will set deliveryFare
    },
    deliveryTooFarAlert() {
      var title = `😢 Too Far`;
      var txt1 = `Sorry, you are too far away to order <strong>delivery</strong> from this shop right now.`;
      var txt2 = `The max delivery distance is currently <strong>${this.maxDistKM}km</strong>. Please try ordering from a shop that is closer to you.`;
      var txt3 = "";
      if (this.isPeakHour) {
        txt3 = `<p style='margin-top:10px'><i>At peak hours 17:00-18:59 max distances are decreased to ensure timely deliveries.</i></p>`;
      }
      this.$swal({
        html: `<div style='text-align:left'>
  <p style='font-size:1.2em; margin-bottom:12px'>${title}</p>
  <p style='margin-bottom:10px'>${txt1}</p>
  <p>${txt2}</p>
  ${txt3}
  </div>`,
        showCloseButton: true,
      });
    },
    // FREE4 promo, currently promos are OFF
    handleFreeDeliveryPromo() {
      if (!this.validForFreeDeliveryPromo()) {
        this.deliveryPromoCode = null;
        return;
      }
      if (this.deliveryFee) {
        this.deliveryFare.tukpay += this.deliveryFee;
        this.deliveryFare.cash = 0; // because it was added to tukpay
        this.deliveryFare.client = 0; // added to tukpay?
        this.deliveryFee = 0;
      }
      if (this.isLalamove && !this.lalamoveQuote) return;
      this.successToast("You get FREE delivery!");
    },
    validForFreeDeliveryPromo() {
      var valid = true;
      if (this.deliveryFare.distance > 5000) {
        var t1 = `Invalid distance for this promo code<br>Max 4km`;
        this.errorToast(t1, "bottom", 12000);
        valid = false;
      }
      // if (this.orderValue < 400) {
      //   var t2 = `Invalid order for this promo code<br>400 baht minimum`;
      //   this.errorToast(t2);
      //   valid = false;
      // }
      return valid;
    },
    // handleCashbackPromo(txt) {
    //   var name = `${this.$store.getters.realName} ${this.$store.getters.phoneNumber}`;
    //   this.sendSuperuserNotification(`💸🎉🔥 CASHBACK (${txt}) ${name}`);
    //   setTimeout(() => this.showCNXPromoInfo(), 200);
    //   this.checkCNXPromo();
    // },
    // checkCNXPromo() {
    //   this.cashback = 0;
    //   if (!this.isDelivery) return;
    //   if (!this.isCNXPromo) return;
    //   if (this.totalValue >= 500) this.cashback = 50;
    //   if (this.totalValue >= 1000) this.cashback = 100;
    //   if (this.totalValue >= 2000) this.cashback = 200;
    //   if (this.totalValue >= 3000) this.cashback = 300;
    // },
    addRemitToFare() {
      // depends on fleet capability, e.g. Lalamove can't remit
      // remit is added to cash to determine the total client pays for delivery
      this.deliveryFare.remit = this.deliveryRemit;
      this.deliveryFare.client = this.deliveryFare.cash + this.deliveryRemit;
    },
    updateDeliveryFee() {
      // this.checkCNXPromo();
      if (!this.deliveryFare) return; // should only call this if deliveryFare is set
      this.addRemitToFare(); // NEW 15 July 2022
      if (this.isFreeDelivery) {
        this.deliveryFee = 0;
        return;
      }
      // this.deliveryFee = this.deliveryFare.cash;
      this.deliveryFee = this.deliveryFare.client;
      if (this.deliverySubsidy) {
        // if (this.deliveryFee < 0) this.deliveryFee = 0;
        if (this.deliverySubsidy > this.deliveryFee) {
          this.deliveryFee = 0;
        } else {
          this.deliveryFee = this.deliveryFee - this.deliverySubsidy;
        }
      }
    },
    selfDeliveryPrice(dist) {
      var km = dist / 1000;
      var price = Math.round(km * this.deliveryFeePerKM); // round to int
      if (price < this.minDeliveryFee) return this.minDeliveryFee;
      return price;
    },
    getFare(p, d) {
      var dist = this.tripDistance(p, d); // straightline dist * 1.25
      var source = "estimate";
      if (this.drivingRoute) dist = this.drivingRoute.distance; // if have driving distance use it
      if (this.drivingRoute) source = this.drivingRoute.source; // graphhopper, google or estimate
      if (this.isLalamove) return { distance: dist }; // gets fare later from API

      // if (this.deliveryPricingArray) return this.getFareFromPricingArray(dist, source);
      var price = null;
      if (this.deliveryPricingArray) {
        price = this.getPriceFromPricingArray(dist); // preferred way to get price
      } else if (this.isSelfDelivery && this.deliveryFeePerKM) {
        price = this.selfDeliveryPrice(dist); // otherwise use self delivery price
      } else {
        price = this.getDefaultDeliveryPrice(dist); // otherwise use default pricing...
      }
      return {
        version: "v1",
        price: price + this.surgeFee + this.extraTukpay + this.extraCash, // total for driver
        discount: 0,
        cash: price + this.extraCash + this.surgeFee,
        tukpay: this.extraTukpay, // + this.surgeFee,
        bonus: this.extraCash + this.extraTukpay + this.surgeFee, // driver bonus over base price
        // remit: this.deliveryRemit,
        distance: dist,
        source: source,
      };
    },
    getFareFromLalamove(fare) {
      this.log("get_lalamove_quote", this.lalamoveRequest);
      this.lalamoveQuote = null; // clear this
      var loader = this.loadingDots(this.bulmaColor("success"));
      this.$store
        .dispatch("getLalamoveQuote", this.lalamoveRequest)
        .then((res) => {
          this.log("get_lalamove_quote_success", res.data);
          console.log("getLalamoveQuote", res.data);
          this.lalamoveQuote = res.data;
          this.deliveryFare = this.setLalamoveFare(fare);
          this.updateDeliveryFee(); // handles free delivery and delivery subsidy
          this.finishSetDeliveryAddress();
        })
        .catch((err) => {
          var errData = { request: this.lalamoveRequest, err: err };
          this.log("get_lalamove_quote_err", errData);
          // this.apiError(err); // shows non-network errors
          if (!fare.attempt) fare.attempt = 2;
          else if (fare.attempt > 5) {
            this.warningToast("Please check your internet<br>and try again.");
          } else {
            this.infoToast("Getting delivery fare...");
            fare.attempt += 1;
            this.getFareFromLalamove(fare);
          }
          var msg = `🤦🏻‍♂️ LALAMOVE getFare ERROR (Attempt #${fare.attempt}): ${this.$store.getters.getNameAndNumber} @ ${this.business.name}`;
          this.sendSuperuserNotification(msg);
        })
        .finally(() => loader.hide());
    },
    setLalamoveFare(fare) {
      return {
        version: "v1",
        price: parseInt(this.lalamoveQuote.totalFee), // total for driver
        discount: 0,
        cash: parseInt(this.lalamoveQuote.totalFee),
        tukpay: 0,
        bonus: 0,
        remit: 0,
        distance: fare.distance,
        source: fare.source,
      };
    },
    getDefaultDeliveryPrice(dist) {
      var price = 80;
      if (dist < 10000) price = 60;
      if (dist < 5000) price = 40;
      if (dist < 3000) price = 30;
      return price;
    },
    getPriceFromPricingArray(distMeters) {
      var km = Math.round(distMeters / 1000);
      if (km) km -= 1; // array start with index 0 for km = 1
      var price = this.deliveryPricingArray[km]; // should have checked length previously
      return price;
    },
    getFareFromPricingArray(distMeters, source) {
      var km = Math.round(distMeters / 1000);
      if (km) km -= 1; // array start with index 0 for km = 1
      var price = this.deliveryPricingArray[km]; // should have checked length previously
      return {
        version: "v1",
        price: price + this.surgeFee + this.extraTukpay + this.extraCash, // total for driver
        discount: 0,
        cash: price + this.extraCash + this.surgeFee,
        tukpay: this.extraTukpay, // + this.surgeFee
        bonus: this.extraCash + this.extraTukpay + this.surgeFee, // driver bonus over base price
        remit: this.deliveryRemit,
        distance: distMeters,
        source: source,
      };
    },
    // getDrivingRouteAndSetFare() {
    //   var o = { pickup: this.pickup, dropoff: this.dropoff };
    //   this.$store
    //     .dispatch("drivingRoute", o)
    //     .then((obj) => {
    //       this.console("getDrivingRoute", obj);
    //       this.drivingDist = obj.distance; // update to actual driving distance
    //       this.drivingRoute = obj.encoded;
    //     })
    //     .catch((err) => console.error("drivingRoute error", err))
    //     .finally(() => this.setFare());
    // },
    tripDistance(p, d) {
      var dist = geo.distanceToUserInMeters(p, d);
      var drivingDist = Math.round(dist * 1.25); //
      this.console(
        `tripDistance ${dist} (${drivingDist} [+ ${this.extraDistance}])`
      );
      return drivingDist + this.extraDistance;
    },
    onlyDeliveryFulfilment() {
      if (!this.fulfilmentOptions) return false;
      var options = this.commerce.data.fulfilment_options;
      if (options.length === 1) {
        if (options[0] === "delivery") {
          this.fulfilmentType = "delivery";
          this.openSetAddressModal(); // set address now...
          return true;
        }
      }
      return false;
    },
    promptFulfilmentType() {
      if (this.onlyDeliveryFulfilment()) return;
      // check if only take-away also
      var green = this.bulmaColor("success");
      var blue = this.bulmaColor("info");
      this.$swal({
        title: `<i class='fa fa-shipping-fast' style='color:${green}; margin-right:10px'></i>
         <i class='fa fa-question-circle' style='color:grey;'></i>
          <i class='fa fa-walking' style='color:${blue}; margin-left:10px'></i>`,
        html: this.$t("menu.fulfilment-how"), //`How would you like to receive your order?`,
        showCancelButton: true,
        confirmButtonText: this.$t("commerce.delivery"),
        cancelButtonText: this.$t("commerce.take-away"),
        confirmButtonColor: green,
        cancelButtonColor: blue,
        allowOutsideClick: false,
      }).then((val) => {
        if (val.value) {
          this.fulfilmentType = "delivery";
          this.openSetAddressModal(); // set address now...
        } else {
          this.fulfilmentType = "take-away";
          this.preSubmit(); // go again!
        }
      });
    },
    promptMinOrder() {
      var msg = `This shop requires a<br>minimum order<br>of ${this.currency}${this.minOrder}`;
      this.infoToast(msg, "bottom", 8000);
    },
    promptMinOrderSongkran() {
      var msg = `<div style='text-align:left'>
        ⚠️ Songkran Festival Delivery<br>Minimum order ${this.currency}${this.songkranMinOrder} ⚠️
        </div>`;
      this.errorToast(msg, "bottom", 12000);
    },
    preSubmit() {
      // return this.setName(this.loginCheckoutCallback);
      var logData = {
        order_value: this.basketValue,
        fulfilment_type: this.fulfilmentType,
      };
      this.log("submit_order_click", logData); // log client_event
      if (this.invalidBasketForShop()) return;
      // TUK Express still allowed if shop is closed
      if (!this.isOpen && !this.agentModeData) {
        return this.$emit("shopWhenOpen");
      }
      if (
        this.minOrder &&
        this.basketValue < this.minOrder &&
        this.isDelivery &&
        !this.agentModeData
      ) {
        return this.promptMinOrder();
      }
      // Songkran min order hack !!!!!!!
      if (this.songkranMinOrder && this.basketValue < this.songkranMinOrder && this.isDelivery) {
        return this.promptMinOrderSongkran();
      }
      if (this.isFreeGiftOrder && this.basketValue < this.freeGiftOver) {
        return this.promptFreeGiftOverRemoval();
      }
      if (!this.fulfilmentType) {
        return this.promptFulfilmentType();
      }
      if (this.isDelivery && !this.address) {
        return this.promptFulfilmentType();
      }
      // if (this.isDelivery && !this.validDelivery()) return;
      if (this.isDelivery && !this.deliveryFare) return;
      if (this.isDelivery && this.isLalamove && !this.lalamoveQuote) {
        this.getFareFromLalamove(this.deliveryFare);
        var lalaErrMsg = `<div style='text-align:left'>😢 Delivery service is<br>temporarily unavailable.<br>Try again in a few minutes.</div>`;
        this.errorToast(lalaErrMsg, "bottom", 9000);
        return;
      }
      this.updateDeliveryFee(); // handles free delivery and delivery subsidy
      var msg = this.$t("menu.one-last-thing");
      if (!this.smsLoginOkay(msg, this.loginCheckoutCallback)) return;
      if (!this.checkMobileNumber()) return; // legacy FB/LINE logins may not have a phone number yet
      this.showSubmit = true; // opens <ShopSubmitOrder />
    },
    prefaceTestOrderNotes() {
      var prefix = "[TEST ORDER] ";
      var notes = this.basket.notes || "";
      this.basket.notes = `${prefix}${notes}`; // add Test prefix to notes
    },
    setLessPlastic() {
      if (this.isLessPlastic) return; // skip if already set
      var prefix = "[🐬 No cutlery, less plastic please 🙏🏼] ";
      var notes = this.basket.notes || "";
      this.basket.notes = `${prefix}${notes}`; // add Test prefix to notes
    },
    contactlessDelivery() {
      var contactlessDelivery = "Contactless delivery";
      var text1 = `Where would you like the driver to leave the goods?`;
      var text2 = `Remember to choose a contactless payment method on checkout.`;
      var example = "Leave it at the front door, Rainhill Condo Unit #7";
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:10px'>
          <i class='fa fa-box'></i>&nbsp;&nbsp;${contactlessDelivery}
        </p>
        <p style='margin-bottom:10px'>${text1}</p>
        <p style='margin-bottom:10px'>${text2}</p>
        <p style='font-size:0.9em; opacity:0.7'><i>${example}</i></p></div>`,
        input: "textarea",
        inputValue: this.contactlessNote,
        showCloseButton: true,
        confirmButtonText: this.$t("save"),
        inputValidator: (txt) => {
          if (!txt) this.contactlessNote = null;
          if (txt.length < 2) return `Enter instructions for the driver`;
        },
      }).then((val) => {
        if (val.value) {
          this.contactlessNote = val.value;
          this.saveBasket();
          this.log("set_contactless_notes", val.value);
          // var name = this.$store.getters.realName || "Unknown";
          // var shop = this.business.name;
          // var msg = `User set contactless notes (${name} @ ${shop}): ${val.value}`;
          // this.sendSuperuserNotification(msg);
        }
      });
    },
    // invalidDragonBox(b) {
    //   if (b.name !== "DragonBox") return false;
    //   // new coords are: 18.794963836669922, 98.97348022460938
    //   // old coords: 18.79121, 98.990234
    //   if (Math.abs(b.lat - 18.794964) < 0.0001) return false;
    //   var name = this.$store.getters.realName || "Unknown";
    //   var msg = `👻 DragonBox wrong lat ${b.lat} for ${name}`;
    //   this.sendSuperuserNotification(msg);
    //   return true;
    // },
    submit(payment) {
      // create commerce transaction!!
      this.paymentMethod = payment.method; // if card and lalamove need to adjust -15b, see below
      if (payment.isTest || this.isTest) this.prefaceTestOrderNotes();
      if (payment.addressNotes) {
        this.address.notes = payment.addressNotes;
        this.saveDeliveryAddress(this.address);
      }
      if (payment.fulfilmentTime) this.fulfilmentTime = payment.fulfilmentTime;
      var business = {
        id: this.business.id,
        country: this.business.country,
        type: this.business.business_type,
        name: this.business.name, // essentially
        lat: this.business.lat, // this is a
        lon: this.business.lon, // modified pickup obj
        phone_number: this.business.data.phone_number, // added 20 Oct 2021
      };
      if (this.locations) {
        business.lat = this.closestPickupLocation().lat;
        business.lon = this.closestPickupLocation().lon;
        business.name = this.business.name + "*"; // could have a name
        // could have a different phone number too
      }
      // if (this.invalidDragonBox(business)) {
      //   business.lat = 18.794964; //18.794963836669922; 18.794964
      //   business.lon = 98.97348; //98.97348022460938; 98.97348
      // }
      var order = {
        type: this.business.business_type, // dupe
        business_name: this.business.name, // dupe
        order_value: this.basketValue,
        payment_method: payment.method,
        delivery_subsidy: this.actualDeliverySubsidy,
        remit:
          this.actualRemitAmount + this.specialDiscount + this.specialRemit, //this.remitAmount - this.actualDeliverySubsidy,
        fulfilment_discount: this.fulfilmentDiscountAmount,
        special_discount: 0, // this.specialDiscount, << deprecated, now used in remit
        vat: this.vat,
        basket: {
          items: this.basket.items,
          notes: this.basket.notes,
          languages: this.languages, // added 18Jul2021
        },
      };
      // if (this.cashback) order.cashback = this.cashback;
      if (payment.changeFor) order.change_for = payment.changeFor;
      if (payment.localContact) order.local_contact = payment.localContact;
      if (this.fulfilmentTime) order.fulfilment_time = this.fulfilmentTime;
      if (payment.id) order.payment_id = payment.id;
      // add a settings object containing VAT_percent, billing_percent etc
      var settings = {
        vat_percent: this.vatPercent,
        billing_percent: this.billingPercent,
        remit_percent: this.remitPercent,
        delivery_subsidy_percent: this.deliverySubsidyPercent,
        fulfilment_discount_percent: this.fulfilmentDiscountPercent,
      };
      var obj = {
        type: this.fulfilmentType,
        business: business,
        order: order,
        settings: settings,
        agent: this.isSuperUser() ? true : false, // allow super users to submit multiple orders
        uuid: this.$store.getters.getUUID,
        start_url: this.$store.getters.getDeviceStartURL,
        ad_tag: this.$store.getters.getAdTag,
        short_id: shortid.generate(),
        ref_prefix: this.commerce.data.ref_prefix, // mostly null
      };
      if (this.autoconfirm) obj.autoconfirm = true;
      if (this.commerce.data.alternative_shop) {
        obj.alternative_shop = this.commerce.data.alternative_shop;
      }
      if (this.isDelivery) {
        var expressFleet = this.commerce.data.express;
        // set Test Fleet
        if (payment.isTest || this.isTest) expressFleet = this.testFleet;
        var delivery = {
          // type: "delayed", // delayed or now
          workflow_id: expressFleet, // very different from delivery transaction delivery object...
          express_fleet: expressFleet, // also store fleet name here since workflow_id will change
          is_free_delivery: this.isFreeDelivery, // flag for customer
          promo_code: this.deliveryPromoCode, // @0909588716
          contactless_note: this.contactlessNote, // added 26 Aug
          business_note: this.businessNoteForDriver, // note for driver on shop
          sign_name: this.businessSignName,
          //   agent_id: this.userID(), // so you can get notified of delivery events
        };
        if (this.paymentMethod === "cash") delivery.contactless_note = null; // cash can't be contactless
        if (this.delayedDelivery) delivery.type = "delayed";
        if (this.delayDuration) delivery.delay_duration = this.delayDuration;
        // force delayed delivery on large orders, todo move to data var
        if (!this.delayedDelivery && this.basketValue >= 1000) {
          delivery.type = "delayed";
          delivery.delay_duration = 26;
          // notify superusers about it
          var name = this.$store.getters.realName || "Unknown";
          var shop = this.business.name;
          var msg = `🤑💰${this.basketValue} Big Order Delay Delivery (${name} @ ${shop})`;
          this.sendSuperuserNotification(msg);
        }
        if (this.thirdPartyDelivery) delivery.type = "third-party";
        if (this.reversedDelivery) delivery.reversed = true;
        if (this.fallbackFleet && !payment.isTest && !this.isTest) {
          delivery.fallback_fleet = this.fallbackFleet;
        }
        if (this.commerce.data.is_mart || this.commerce.data.require_receipt) {
          delivery.require_receipt = true; // e.g. McDonald's, 7-11, anything where driver buys, no commerce agent
        }
        if (this.commerce.data.is_mart) {
          delivery.is_flexible_pickup_location = true;
        }
        if (this.requiresLargeBox) {
          delivery.is_large = true;
        }
        if (this.lalamoveQuote) {
          delivery.lalamove = {
            ...this.lalamoveQuote,
            ...this.lalamoveRequest,
          };
          if (this.paymentMethod === "card" || this.basketValue === 0) {
            // or if paid via any non lalamove cod
            delivery.lalamove.total_price = 0; // already paid
            var newFee = parseInt(delivery.lalamove.totalFee) - 15; // remove COD fee
            delivery.lalamove.totalFee = newFee.toString(); // convert back to string
          }
          // delivery.lalamove.totalFee = "9999999"; // hack to test PRICE_MISMATCH fix
        }
        if (this.drivingRoute) {
          delivery.predicted_route = this.drivingRoute.encoded;
        }
        obj.coords_created = this.$store.getters.getUserLatLon;
        obj.delivery = delivery;
        obj.address = this.address;
        obj.fare = this.deliveryFare;
        if (payment.driverTip) {
          obj.fare.client += payment.driverTip;
          obj.fare.cash += payment.driverTip;
          obj.fare.price += payment.driverTip;
          obj.fare.tip += payment.driverTip;
        }
        if (parseFloat(this.billingAmount) > 0)
          obj.billing = this.billingAmount;
        // if (parseFloat(this.remitAmount) > 0) obj.remit = this.remitAmount;
        if (this.giftDetails) obj.gift_details = this.giftDetails;
      }
      var createdBy = this.userID();
      if (this.agentModeData) {
        createdBy = this.agentModeData.mobile;
        obj.autoconfirm = true;
        obj.is_agent_order = true;
      }

      console.log("createTransaction", obj);
      var loader = this.loadingDots(this.bulmaColor("info"));
      this.$store
        .dispatch("createTransaction", {
          workflow_type_name: "Commerce",
          workflow_id: this.commerce.id,
          business_id: this.business.id,
          created_by: createdBy,
          data: obj,
        })
        .then(() => {
          this.newBasket();
          if (this.agentModeData) {
            this.$swal({
              html: `<div style='text-align:left'>
              <p style='font-size:1.2em; margin-bottom:12px'>
              <i class='far fa-thumbs-up'></i>&nbsp;Order Created
              </p>
              <p style='margin-bottom:10px'>Confirm the order now to request the driver.</p>
              <p>Click <strong>Share to customer&nbsp;<i class='fa fa-paper-plane'></i></strong> 
              &nbsp;to share the order link to the customer.</p>
              </div>`,
              confirmButtonText: this.$t("okay"),
              showCloseButton: true,
            });
            this.goto("ecommerce"); // if agent mode they should go accept it
            // var msg = `Remember to confirm the order ✔<br>And share the tracking link 🔗 with customer`;
            // setTimeout(() => this.successToast(msg), 2000);
          } else {
            var green = this.bulmaColor("success");
            var text1 = this.$t("menu.confirmed-1");
            var text2 = this.$t("menu.confirmed-2");
            this.$swal({
              title: `<i class='fa fa-thumbs-up' style='color:${green}'></i>`,
              html: `${text1}<br><br>${text2}`,
              showConfirmButton: true,
              confirmButtonColor: green,
              confirmButtonText: this.$t("okay"),
              // timer: 2000
            }).then(() => {
              var msg = this.$t("menu.see-your-ongoing-orders") + " 👆🏻";
              setTimeout(() => this.successToast(msg), 1000);
            });
            this.goto("orders?tab=ongoing"); // go to orders tab straight away
          }
          //// -- facebook pixel tracker --
          // var data = { currency: "THB", value: this.basketValue };
          // fbq("track", "Purchase", data);
          this.log("submit_order_success", obj);
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    editOrderNotes() {
      var orderNotes = this.$t("menu.order-notes");
      var text = this.$t("menu.food-prep-?");
      var example = this.$t("menu.food-prep-example");
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:10px'>
          <i class='far fa-comment-alt'></i>&nbsp;&nbsp;${orderNotes}
        </p>
        <p style='margin-bottom:10px'>${text}</p>
        <p style='font-size:0.9em; opacity:0.7'><i>${example}</i></p></div>`,
        input: "textarea",
        inputValue: this.basket.notes || "",
        showCloseButton: true,
        confirmButtonText: this.$t("save"),
        inputValidator: (txt) => {
          this.basket.notes = txt;
          this.saveBasket();
          this.log("set_order_notes", txt);
          var name = this.$store.getters.realName || "Unknown";
          var shop = this.business.name;
          var msg = `Order notes (${name} @ ${shop}): ${txt}`;
          if (txt) {
            if (this.isLessPlastic && txt.length < 44) return null;
            this.sendSuperuserNotification(msg); // only send if more than less plastic msg
          }
          return null;
        },
      }).then((val) => {
        if (val.value) {
          this.$swal({
            html: `<div style='text-align:left'>
            <p style='font-size:1.2em; margin-bottom:10px'>🙏🏼 Thank you</p>
            <p>If this note is related to <strong>dietary constraints</strong> or 
            <strong>order preparation</strong> please call the shop after placing 
            your order to ensure they understand your requirements.</p>
            </div>`,
            showCloseButton: true,
          });
        }
      });
    },
    // copied this to setAddress
    editDeliveryNotes() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-shipping-fast fa-sm'></i>&nbsp;
        Set Delivery Notes
        </p>
        <p style='margin-bottom:10px'>Is there anything the driver should know about the delivery location?</p>
        <p><i style='color:grey'>Unit #, house #, building name etc.</i><p>
        </div>`,
        input: "textarea",
        inputValue: this.address.notes || "",
        showCloseButton: true,
        confirmButtonText: this.$t("save"),
        inputValidator: (txt) => {
          this.address.notes = txt;
          this.saveBasket();
          if (this.userID()) this.saveDeliveryAddress(this.address);
          this.z += 1;
          return null;
        },
      });
    },
    manualPriceHint() {
      this.$swal({
        title: `<i class='fa fa-coins' style='color:lightgreen'></i>`,
        html: `Enter the price from the menu or the estimated price if it's not on the menu.<br><br>The shop will confirm the price and availability with you.`,
        showCloseButton: true,
        showConfirmButton: false,
      });
    },
    initBasket() {
      console.log("INIT basket");
      if (this.$store.state.basket) {
        var bs = this.$store.state.basket;
        var t0 = new Date(bs.created_at).getTime();
        var age = (new Date().getTime() - t0) / (1000 * 60); // minutes
        console.log(`basket age ${age} minutes`);
        if (age > 60 && bs.shop_id !== this.business.id) {
          this.newBasket(); // make new basket here if older than 60 minutes
        } else {
          this.basket = this.$store.state.basket; // otherwise use the old basket
        }
      } else {
        this.newBasket();
      }
    },
    invalidBasketForShop(o) {
      if (!this.basket) this.newBasket();
      if (this.basket.shop_id === this.business.id) return false; // same shop
      if (this.basketItemCount === 0) {
        this.newBasket(); // if no items then create new basket
        return false;
      }
      var green = this.bulmaColor("primary");
      var differentShop = this.$t("menu.different-shop");
      var shopHere = this.$t("menu.shop-here?");
      var title = this.$t("menu.shop-here");
      this.$swal({
        // title: `<i class='fa fa-shopping-basket'></i>`,
        html: `<div style='text-align:left'>
          <p style="font-size:1.2em; margin-bottom:16px">
          <i class='fa fa-shopping-basket'></i>&nbsp;${title}?
          </p>
          <p style='margin-bottom:10px'>${differentShop}</p>
          <p>${shopHere}</p>
          </div>`,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: this.$t("menu.yes-shop-here"),
        cancelButtonText: this.$t("menu.go-to-other"),
        confirmButtonColor: green,
        cancelButtonColor: "orange",
      }).then((val) => {
        if (val.value) {
          this.newBasket();
          if (o) this.addToBasket(o, true); // callback adds to new basket
        }
        if (val.dismiss === "cancel") {
          this.goto(`shop/${this.basket.shop_id}?tab=promos`); // go to other shop
          this.$nextTick(() => this.$emit("reactivateShopProfile"));
          // setTimeout(() => this.$emit("reactivateShopProfile"), 1000);
        }
      });
      return true;
    },
    newBasket() {
      this.basket = {
        shop_id: this.business.id,
        created_at: new Date(),
        items: [],
        notes: null,
      };
      this.saveBasket();
      this.showBasket = false;
    },
    clearBasket() {
      this.$swal({
        // title: `<i class='fa fa-trash-alt'></i>`,
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='far fa-trash-alt'></i>&nbsp;Clear Basket
        </p>
        <p>${this.$t("menu.clear-basket-?")}</p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonColor: this.bulmaColor("danger"),
        cancelButtonColor: this.bulmaColor("primary"),
        confirmButtonText: this.$t("menu.clear-basket"),
        cancelButtonText: this.$t("menu.keep-shopping-btn"),
      }).then((val) => {
        if (val.value) this.newBasket();
      });
    },
    saveBasket() {
      this.sortBasket();
      this.$store.commit("setBasket", this.basket);
    },
    manualItemInfo() {
      var blue = this.bulmaColor("info");
      this.$swal({
        html: `<div style='text-align:left'>
        <p style="font-size:1.2em; color:grey"><i class='fa fa-pencil-alt'></i>&nbsp;Add Manual Item</p>
        <p style="margin-top:10px">
        1. Tap the menu icon
        <i class='fa fa-book-open' style='color:${blue}; padding:4px'></i>
        to see the full menu.
        </p>
        <p style="margin-top:10px">
        2. Enter the name and price of any item.
        </p>
        <p style="margin-top:10px">
        3. Click the
        <i class='fa fa-chevron-right' style='color:${blue}; padding:4px'></i>
         button to add to your basket.
         </p>`,
        //  <p style='font-size:2em'>🥳</p>`,
        showCloseButton: true,
        showConfirmButton: false,
      });
    },
    addManualItem() {
      if (!this.manualItemName || !this.manualItemPrice) {
        return this.manualItemInfo();
      }
      var manualItem = {
        id: "~" + shortid.generate(), // needs a random ID, stat with ~
        name: this.manualItemName,
        price: this.manualItemPrice,
        description: "จากเมนู (From menu)",
      };
      this.manualItems.push(manualItem); // needed to show on order page
      this.addToBasket(manualItem, true);
      this.manualItemName = null;
      this.manualItemPrice = null;
    },
    triggerOptions(o) {
      this.selectedItem = this.items.find((i) => i.id === o.id); // get the original item
      // console.log("showOptions", o.options, this.optionsMenus);
      // this.selectedItem = o;
      this.showOptions = true;
    },
    sortBasket() {
      this.basket.items.sort((a, b) => {
        return a.item.name.localeCompare(b.item.name); // sort the basket by item names
      });
    },
    // this is addToBasket from options panel
    submitOptions(o) {
      this.log("add_to_basket", o);
      console.log("submitOptions", o);
      // console.log("basket 1", this.basket.items);
      if (o.comment) {
        var orig = this.promos.data.find((i) => i.id === o.id);
        if (orig) orig.comment = o.comment;
      }
      if (o.id2) {
        this.basket.items.push({ item: o, quantity: 1 });
      } else {
        var existing = this.basket.items.find((i) => i.item.id === o.id);
        if (existing) {
          existing.quantity += 1;
          existing.item.comment = o.comment; // update the comment
        } else {
          this.basket.items.push({ item: o, quantity: 1 });
        }
      }
      this.saveBasket();
      this.updateDeliveryFee();
      // console.log("basket 2", this.basket.items);
      this.$refs[o.id][0].forceAnimate("add"); // animate normal item
      if (!this.$refs["special" + o.id]) return;
      this.$refs["special" + o.id][0].forceAnimate("add"); // animate special item
    },
    addToBasket(o, hideToast) {
      EventBus.$emit("BREAK_SHOP_CACHE");
      this.log("view_menu_item", o);
      if (o.hasOwnProperty("isTrusted")) return; // hack to fix {"isTrusted":true} edge case
      if (!this.basket) this.initBasket(); // should already be initiated, but hot-reload on dev may not
      if (this.invalidBasketForShop(o)) return;
      // add reminder about shop being closed
      if (!this.isOpen) this.$emit("shopWhenOpen"); // just warning, still allows user to add
      if (hideToast) {
        this.triggerOptions(o);
        return;
      } else {
        var existing2 = this.basket.items.find((i) => i.item.id2 === o.id2);
        if (existing2) existing2.quantity += 1;
      }
      this.finishAddition(hideToast);
    },
    finishAddition(hideToast) {
      this.saveBasket();
      this.updateDeliveryFee();
      var added = this.$t("menu.added-to-basket");
      var msg = `<i class='fa fa-plus'></i>&nbsp;${added}`;
      if (hideToast) return; // skip toast
      this.$toast.open({ message: msg, duration: 500 }); // successToast
    },
    removeZeros() {
      var items = this.basket.items;
      for (var i = 0; i < items.length; i++) {
        if (items[i].quantity === 0) items.splice(i, 1);
      }
    },
    advancedRemoval(o) {
      // this.removeFromBasket(o, )
      this.showOptions = false;
      if (this.itemQuantity(o) === 1) {
        var existing = this.basket.items.find((i) => i.item.id === o.id);
        if (existing) existing.quantity -= 1;
        this.finishRemoval(true);
        this.$refs[o.id][0].forceAnimate("remove");
      } else {
        // this.checkout();
        // var msg = "Choose which item to remove";
        // setTimeout(() => this.infoToast(msg), 800);
        // replacing this...
        this.itemForRemoval = o;
        this.showRemoval = true;
      }
    },
    removeFromBasket(o, hideToast) {
      // console.log("remove", o);
      if (o.options && o.options.length && this.itemQuantity(o) > 1) {
        this.itemForRemoval = o;
        this.showRemoval = true;
        // if (hideToast) {
        //   this.checkout();
        //   var msg = "Choose which item to remove";
        //   setTimeout(() => this.infoToast(msg), 800);
        //   return;
        // } else {
        //   // means user is removing from basket not menu
        //   var existing2 = this.basket.items.find((i) => i.item.id2 === o.id2);
        //   if (existing2) existing2.quantity -= 1;
        // }
      } else {
        var existing = this.basket.items.find((i) => i.item.id === o.id);
        if (existing) existing.quantity -= 1;
      }
      this.finishRemoval(hideToast);
    },
    newRemoveFromBasket(o) {
      var existing2 = this.basket.items.find((i) => i.item.id2 === o.id2);
      if (existing2) existing2.quantity -= 1;
      this.finishRemoval(false);
      this.$refs[o.id][0].forceAnimate("remove");
    },
    finishRemoval(hideToast) {
      if (!hideToast || this.showBasket) {
        var removed = this.$t("menu.removed-from-basket");
        var html = `<i class='fa fa-minus'></i>&nbsp;${removed}`;
        this.warningToast(html);
      }
      this.removeZeros(); // quantity could be 0, if so remove
      this.saveBasket();
      this.updateDeliveryFee();
      console.log("finishRemoval", this.basket.items.length);
      if (!this.basket.items.length) this.minimise();
      // var removed = this.$t("menu.removed-from-basket");
      // if (hideToast && !this.showBasket) return; // skip toast
      // var html = `<i class='fa fa-minus'></i>&nbsp;${removed}`;
      // this.warningToast(html);
    },
    itemQuantity(o) {
      if (!this.basket) return null;
      // var item = this.basket.items.find((i) => i.item.id === o.id);
      // if (!item) return null;
      // return item.quantity;
      var items = this.basket.items.filter((i) => i.item.id === o.id);
      var sum = 0;
      items.forEach((i) => (sum += i.quantity));
      return sum;
    },
    itemName(o) {
      if (o[this.lang]) {
        return o[this.lang].name;
      }
      return o.name;
    },
    itemDescription(o) {
      if (o[this.lang]) {
        return o[this.lang].description;
      }
      return o.description;
    },
    pic(o) {
      // if (!o.pic) return this.$store.state.errorProfilePic;
      return o.pic || this.$store.state.menuItemPlaceholderPic;
    },
    openMenu() {
      this.displayModal(".shop-menu-modal");
      EventBus.$emit("OPEN_SHOP_MENU");
    },
  },
};
</script>

<style scoped>
.shop-promos-tab {
  /* position: relative; */
  height: calc(100vh - 100px);
  width: 100vw;
  /* overflow: auto; */
  overflow: hidden;
  max-width: 700px;
  margin: auto;
  box-shadow: -1px 0px 0px 0px #eee, 1px 0px 0px 0px #eee;
}

.card {
  box-shadow: 0 0 1px #ddd;
  /* background-color: whitesmoke; */
}

.card-content {
  padding: 12px;
  text-align: left;
}

.tags {
  margin-bottom: 0;
}

.tag {
  padding: 0 8px;
  margin-bottom: 0;
}

.columns {
  overflow: hidden;
  height: 100%;
  width: 100%;
  padding-right: -12px;
}

.column {
  height: 100%;
  width: 100%;
}

.column {
  padding-right: 0;
}

.notification {
  margin-bottom: 0;
  padding: 16px;
}

.menu-item::before,
.menu-item::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  border-color: transparent;
  border-style: solid;
}

.menu-item::before {
  border-width: 1.5em;
  border-right-color: #ccc;
  border-top-color: #ccc;
}

.menu-item::after {
  border-radius: 4px;
  border-width: 1.35em;
  /* hsl(141, 53%, 53%); <-- success green */
  /* #0c0 <-- original green */
  border-right-color: hsl(171, 100%, 41%);
  border-top-color: hsl(171, 100%, 41%);
}

.item-quantity {
  position: absolute;
  right: 4px;
  top: 0;
  z-index: 1;
  color: white;
  font-size: 1.2em;
  text-shadow: 1px 1px 1px #333;
}

.fulfilment-wrapper {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 10px;
  padding: 4px 0;
}

.table-wrapper {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 10px;
  overflow: hidden;
}

.table {
  border-radius: 5px;
  margin: 4px 0;
  /* margin-bottom: 8px;
  margin-top: 8px; */
  /* border: 1px solid lightgrey; */
}

td,
th {
  padding: 5px 7px;
}

th i {
  opacity: 0.8;
  color: grey;
}

.button {
  padding: 5px 8px;
}

.media-left {
  margin-right: 12px;
}

.single-line {
  white-space: nowrap;
  overflow: auto;
  display: inline-block;
}

.notes {
  padding: 8px;
  /* margin-bottom: 8px; */
  background-color: white;
  border-radius: 6px;
}

.discount {
  font-size: 12pt;
  color: white;
  margin-right: 4px;
  padding: 3px;
  border: 1px dashed white;
  border-radius: 4px;
  background-color: #ff3860;
}

@keyframes shadow-pulse-gold {
  0% {
    box-shadow: 0 0 0 0px rgba(247, 211, 8, 0.95);
  }

  100% {
    box-shadow: 0 0 0 6px rgba(247, 211, 8, 0.2);
  }
}

.pulse {
  animation: shadow-pulse-gold 1s infinite;
}

.basket {
  text-align: left;
  width: 100vw;
  max-width: 700px;
  /* height: calc(100vh - 183px); */
  /* height: calc(100vh - 100px); */
  /* height: calc(100vh - 143px); */
  height: calc(100vh - 151px);
  overflow: scroll;
  position: absolute;
  z-index: 2;
  border-radius: 0;
  padding: 10px 4px;
  background-color: white;
}

.hint {
  font-weight: 600;
  color: #bbb;
}

.has-text-orange {
  color: orange;
}

.is-orange {
  background-color: orange;
}

.fa-pencil-alt {
  color: #209cee;
  opacity: 0.7;
  font-size: 0.9em;
}

/* clamp ellipsis to 2 lines */
.clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  /* padding-right: 4px; */
}

.dinein-wrapper {
  padding: 8px 12px;
  text-align: left;
  opacity: 0.9;
  padding-bottom: 0;
}

.preface {
  padding: 8px 12px;
  text-align: left;
  /* font-style: italic; */
  /* font-weight: 450; */
  opacity: 0.8;
}

.promo-code {
  /* padding: 0 4px; */
  /* font-size: 0.9em; */
  font-weight: 500;
  /* height: 1.5em; */
  font-size: 0.8em;
  white-space: nowrap;
}

.change {
  float: right;
  font-weight: 500;
  font-size: 0.8em;
}

.mb-10 {
  margin-bottom: 10px;
}

.tr-tall {
  height: 66px;
}

.tr-options {
  position: fixed;
  width: calc(100vw - 55px);
  font-size: 0.85em;
  background-color: rgba(224, 255, 255, 0.7);
  padding: 2px;
  border-radius: 3px;
  /* overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical; */
}

.tr-options i {
  display: inline-block;
  width: calc(100vw - 55px);
  vertical-align: bottom;
}

.dine-in-hint {
  font-size: 0.85em;
  font-weight: 500;
  opacity: 0.66;
}

.plus-minus {
  padding-left: 0;
  white-space: nowrap;
  text-align: right;
}

.options {
  /* background-color: rgba(255, 255, 0, 0.6); */
  /* background-color: rgb(236, 236, 236); */
  padding: 2px;
  border-radius: 3px;
  /* margin-left: -6px; */
  margin-left: 5px;
  margin-top: -6px;
  width: calc(100% + 12px);
}

.td-options {
  padding-top: 0;
}

.options td {
  border-bottom: 1pt solid black;
  padding: 2px 6px;
}

.option-menu {
  font-weight: 500;
  opacity: 0.5;
  font-size: 0.9em;
}

.no-bottom-border td {
  border-bottom: none;
  /* padding-bottom: 0; */
}

tbody.items {
  width: 100%;
  /* border-bottom: 1px solid rgb(215, 215, 215); */
  border-bottom: 1px solid #eee;
}

.no-border {
  border: initial;
}

.link {
  border-bottom: 1px #ccc dotted;
}

.grid-view-wrapper {
  display: inline-flex;
  flex-wrap: wrap;
  align-content: flex-stretch;
  /* justify-content: flex-start; */
  justify-content: center;
  /* align-content: center;
  align-items: center;
  justify-items: center; */
}

.delivery-promo-msg {
  /* background-color: rgba(255, 255, 0, 0.5); */
  margin: -3px;
  margin-top: 6px;
  padding: 3px;
  border-radius: 4px;
  border: 1px solid lightskyblue;
}

.delivery-promo-wrapper {
  margin-top: 6px;
  margin-bottom: 10px;
  /* padding: 3px; */
  padding: 6px 10px;
  border-radius: 4px;
  border: 1px solid lightskyblue;
}

.scrollable {
  /* max-height: calc(100% - 62px); */
  max-height: 100%;
  overflow: scroll;
  will-change: transform;
  width: 100vw;
  overflow-x: hidden;
  max-width: 700px;
  margin: auto;
}

.scrollable-short {
  /* was 100% - 62px */
  max-height: calc(100% - 50px);
}

.floating-btn-right {
  width: 36px;
  position: absolute;
  right: 8px;
  bottom: 14px;
  font-size: 1.1em;
  /* text-shadow: 1px 2px 3px rgba(0, 0, 0, 0.5); */
  /* text-shadow: 0 0 1px #444; */
  /* color: whitesmoke; */
  color: #ccc;
  text-shadow: 1px 1px 1px #555;
}

.floating-btn-left {
  width: 36px;
  position: absolute;
  left: 8px;
  bottom: 14px;
  font-size: 1.1em;
  /* text-shadow: 1px 2px 3px rgba(0, 0, 0, 0.5);
  color: whitesmoke; */
  color: #ccc;
  text-shadow: 1px 1px 1px #555;
}

.floating-btn-center {
  width: calc(100vw - 90px);
  /* width: 100vw; */
  position: absolute;
  bottom: 10px;
  left: 40px;
}

.bottom-checkout-wrapper {
  position: absolute;
  /* position: fixed; */
  bottom: 0;
  /* left: 0; */
  width: 100vw;
  max-width: 700px;
  padding: 10px;
  background-color: rgba(255, 255, 255);
  /* background-color: rgba(0, 0, 0, 0.05); */
  backdrop-filter: blur(2px);
  box-shadow: 0 0 8px lightgrey;
  font-weight: 500;
}

.button span {
  padding: 2px 0;
}

.bottom-pay-btn {
  /* position: sticky;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0 8px; */

  /* background-color: rgb(255, 255, 255); */
  /* box-shadow: 0 0 8px lightgrey; */

  position: absolute;
  bottom: 0;
  width: 100vw;
  max-width: 700px;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(1px);
  box-shadow: 0 0 8px lightgrey;
  font-weight: 500;
  z-index: 3;
}

.contain-img {
  object-fit: contain !important;
}


.item-img {
  display: block;
  object-fit: cover;
  height: 140px;
  width: 140px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
  border-radius: 3px;
  margin-top: 3px;
}

img {
  margin: -1px;
  border-radius: 2px;
  object-fit: cover;
  height: 110px;
  width: 110px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
}

.back-btn-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 60px;
  height: 56px;
  /* background-color: rgba(255, 255, 255, 0.1); */
  z-index: 21;
}

.pulse-background {
  animation-name: bgColorPulse;
  animation-duration: 2s;
  animation-iteration-count: 3;
}

@keyframes bgColorPulse {
  0% {
    background-color: white;
  }

  50% {
    /* background-color: #4286f460; */
    background-color: cyan;
  }

  100% {
    background-color: white;
  }
}

.view-items {
  margin-left: 2px;
  margin-right: 6px;
  padding: 0 2px;
  font-size: 0.8em;
}

.qty-left {
  line-height: 1.2em;
  display: inline-block;
  padding: 0 7px;
  padding-top: 3px;
  /* margin-bottom: 2px; */
  border-radius: 3px;
  border: 1px solid #209cee;
  font-weight: 500;
  margin-right: 4px;
}

.qty-total {
  line-height: 1.2em;
  display: inline-block;
  padding: 0 7px;
  padding-top: 3px;
  border-radius: 3px;
  border: 1px solid black;
  font-weight: 550;
  margin-right: 4px;
}

.checkout.button {
  /* width: 100%; */
  /* text-align: left; */
  display: table;
  /* width: calc(100vw - 104px); */
  width: 100%;
  margin: 0 auto;
}

.checkout.button>span {
  /* position: absolute;
  top: 50%;
  margin-top: -22px; */
  /* display: inline-block; */
  /* padding: 9px; */
  /* line-height: 45px; */
  display: table-cell;
  vertical-align: middle;
}

.wide {
  width: 100%;
}

.keep-shopping {
  font-size: 1.2em;
  opacity: 0.8;
  font-weight: 500;
  padding: 9px 4px;
}

.vertical-divider {
  font-size: 1.8em;
  font-weight: 200;
  display: inline-block;
  position: absolute;
  margin-left: -0px;
  margin-top: -15px;
  opacity: 0.5;
  color: lightgreen;
}

.items-price {
  color: rgba(255, 255, 255, 0.7);
  /* font-weight: 500; */
}

.go-up-btn {
  position: absolute;
  /* right: max(calc((100vw - 700px) / 2), 0px); */
  right: 0;
  top: 70px;
  background-color: white;
  padding: 5px 18px;
  border-radius: 4px;
  color: grey;
  z-index: 4;
}

@media only screen and (min-width: 700px) {
  .go-up-btn {
    right: calc((100vw - 700px) / 2);
  }
}

.not-delivery {
  text-transform: uppercase;
  font-size: 8pt;
  font-weight: 550;
  height: 0;
  margin-top: -6px;
  text-align: right;
  opacity: 0.7;
}

.table-number {
  text-transform: uppercase;
  font-size: 8pt;
  font-weight: 550;
  height: 0;
  margin-top: -6px;
  text-align: right;
  opacity: 0.7;
}

.flash-deals {
  text-align: left;
  font-weight: 500;
  border-radius: 0;
}

.flash-deals.is-white {
  /* border-bottom: 1px solid #eee; */
  border-bottom: 1px solid #eee;
  box-shadow: inset 0 0 0 3px var(--warning);
}

.flash-deals.red {
  box-shadow: inset 0 0 0 3px var(--danger);
}

.flash-deals.has-text-info {
  box-shadow: inset 0 0 0 3px var(--info);
}

.member-selected {
  box-shadow: inset 0 0 0 3px var(--primary);
}

.discount-tag {
  opacity: 0.7;
  font-size: 0.7em;
}

.tuk-express-wrapper {
  padding: 6px 12px;
  text-align: left;
  background-color: white;
}

.tuk-express {
  font-size: 14pt;
  font-weight: 550;
  color: #fac002;
  position: absolute;
  margin-top: 3px;
  margin-left: 3px;
  /* font-style: italic; */
  /* position: absolute; */
}

.tuk-express-details {
  padding: 4px 6px;
  margin-top: 6px;
  /* border-radius: 0; */
}

.tuk-express-details .fa {
  display: inline-block;
  width: 28px;
  /* text-align: center; */
}

.total-sol {
  position: absolute;
  white-space: nowrap;
  right: 4px;
  background-color: var(--crypto-secondary);
  padding: 0 4px;
  border-radius: 3px;
  color: black;
  /* font-size: 0.85em; */
}

.total-sol-2 {
  white-space: nowrap;
  margin-right: 10px;
  background-color: var(--crypto-secondary);
  padding: 0 4px;
  border-radius: 3px;
  color: black;
}

.search-no-result {
  padding: 20px;
  background-color: white;
  font-weight: 500;
}

.test-only {
  background-color: var(--danger);
  color: white;
  font-weight: 500;
}

.address-notes {
  /* margin: -4px;
  margin-top: 4px;
  margin-bottom: -8px; */
  margin: 4px -4px -8px -4px;
  padding: 0 6px;
  background-color: whitesmoke;
  border-radius: 4px;
}

.order-option-row {
  /* padding: 4px; */
  /* margin-bottom: 4px; */
  /* margin-top: -4px; */
  padding: 4px 0;
}

.by-weight {
  font-size: 0.8em;
  font-weight: 500;
}

.toggle-out-of-stock {
  background-color: white;
  padding: 20px;
  margin-top: 4px;
  color: grey;
  font-weight: 500;
}
</style>